export default {
  Archive: 'Архів',
  Administrator: 'Адміністратор',
  administrator: 'Адміністратор',
  Accountant: 'Бухгалтер',
  accountant: 'Бухгалтер',
  All: 'Всі',
  Add: 'Додати',
  'All documents': 'Всі документи',
  'Account settings': 'Налаштування профілю',
  Basket: 'Кошик',
  'Invite a user': 'Запросити користувача',
  'Document name': 'Назва документа',
  'Document name required': 'Назва документа*',
  'Document type': 'Тип документа',
  'Select your organization': 'Оберіть свою організацію',
  'Select your organization required': 'Оберіть свою організацію*',
  'Document total': 'Сума документа',
  Continue: 'Продовжити',
  Change: 'Змінити',
  Sign: 'Підписати',
  'To sign': 'Підписувати',
  Signature: 'Підпис',
  Send: 'Надіслати',
  Reject: 'Відхилити',
  'Sign and send': 'Підписати та надіслати',
  'Sign type': 'Тип підписання',
  Date: 'Дата',
  'Date required': 'Дата*',
  'Sign order': 'Порядок підписання',
  'Document number': 'Номер документа',
  'Document number required': 'Номер документа*',
  'Download document': 'Завантажити документ',
  'Download documents': 'Завантажити документи',
  Counterpart: 'Контрагент',
  Counterparts: 'Контрагенти',
  'Email required': 'Email*',
  'Edrpou required': 'ЄДРПОУ*',
  Types: 'Типи',
  Statuses: 'Статуси',
  types: 'типи',
  counterparts: 'контрагенти',
  statuses: 'статуси',
  Edrpou: 'ЄДРПОУ',
  'Click to download': 'Натисніть, щоб завантажити',
  'or drag and drop the file in the format:': 'або перетягніть файл в форматі:',
  Downloaded: 'Завантажено',
  Download: 'Завантажити',
  Document: 'Документ',
  Documents: 'Документи',
  'Required fields': '*Поля обовʼязкові',
  'File format is not allowed to download': 'Формат файлу не є доступним для завантаження',
  'Select eds key': 'Оберіть ключ ЕЦП',
  'Organization exists': 'Організація з цим ЄДРПОУ вже зареєстрована',
  'Organization successfully added': 'Організацію успішно додано',
  'There are no documents': 'Документів немає',
  'There are no organizations': 'Організацій немає',
  'There are no users': 'Користувачів немає',
  'View your current membership roles and the list of organizations you manage':
    'Перегляньте свої поточні ролі членства і список організацій, якими ви керуєте. Ви можете приєднатися тільки до однієї організації як член, це застосує до вас усі налаштування організації. Тим паче, ви можете керувати кількома організаціями як модератор або адміністратор. Адміністратори можуть переглядати всі документи учасників.',
  'To start working with documents, you need to add an organization':
    'Щоб почати роботу з документами, вам потрібно додати організацію',
  'It looks like your organization does not have any users with member roles':
    'Схоже, у вашій організації немає користувачів із ролями учасників',
  'Add document': 'Додати документ',
  Login: 'Вхід',
  Password: 'Пароль',
  'Forgot password?': 'Забули пароль?',
  'No account': 'Немає акаунта',
  'To register': 'Зареєструватися',
  Registration: 'Реєстрація',
  'Already have an account?': 'Вже є акаунт?',
  'Log in': 'Увійти',
  Phone: 'Телефон',
  'First name': 'ПІБ',
  'Confirm password': 'Підтвердження паролю',
  'Clear filter': 'Очистити фільтр',
  clear: 'очистити',
  Period: 'Період',
  choose: 'вибрати',
  Choose: 'Вибрати',
  Cleanup: 'Очистити',
  'To archive': 'В архів',
  Delete: 'Видалити',
  'Which meets filter values': 'Які відповідають критеріям фільтру',
  'Logout from account': 'Вийти з акаунта',
  'My organizations': 'Мої організації',
  'Add organization': 'Додати організацію',
  Name: 'Назва',
  EDRPOU: 'ЄДРПОУ',
  Participants: 'Участників',
  Role: 'Роль',
  'Go to organization': 'Перейти в організацію',
  'Add users': 'Додати користувачів',
  'In the fields, specify which users you want to add and assign them a role in the organization':
    'У полях вкажіть яких користувачів ви хочете додати та задайте їм роль в організації',
  'Enter email': 'Введіть адресу електронної пошти',
  'Enter users role': 'Вкажіть роль користувачів',
  Owner: 'Власник',
  owner: 'Власник',
  'User management': 'Управління користувачами',
  'Invitations have been sent': 'Запрошення надіслано',
  'Change access': 'Зміна доступа',
  'You can change role of this user': 'Ви можете змінити роль данного користувача',
  'in the list of organizations or delete him there': 'для органзацій або видалити його',
  'Enter user roles': 'Вкажіть роль користувачів',
  'We can not find users...': 'Користувача з даною поштовою адресою не існує у системі',
  'As soon as users confirm the entry, you will receive a notification by mail':
    'Як тільки користувачі підтвердять вступ, вам прийде повідомлення на пошту',
  'Manage members by adding or removing them from your organization. Assign moderators or administrators to manage organization members, change organization settings, and more.':
    'Керуйте учасниками, додаючи або видаляючи їх з організації. Призначте модераторів або адміністраторів для управління членами організації, зміни налаштувань організації та багато чого іншого.',
  'Users role': 'Роль користувачів',
  'Change role': 'Змінити роль',
  Organization: 'Організація',
  Organizations: 'Організації',
  Users: 'Користувачі',
  'User role has been successfully changed': 'Роль користувача було успішно змінено',
  'User has been successfully deleted': 'Користувача було успішно видалено',
  'will be canceled and it will be removed from the user list':
    'буде скасовано, і його буде видалено зі списку користувачів',
  Invite: 'Запрошення',
  'Come back': 'Повернутись назад',
  'Delete user': 'Видалити користувача',
  'User deletion': 'Видалення користувача',
  'Forgot your password?': 'Забули свій пароль?',
  'Forgot password': 'Забули пароль',
  'Enter your email address and we`ll send you a link to reset your password.':
    'Введіть свою електронну адресу та перейдіть за посиланням для відновлення пароля.',
  'To login page': 'На сторінку входу',
  'Original document': 'Оригінальний документ',
  'Signed document': 'Підписаний документ',
  'Signed document (format p7s)': 'Підписаний документ (В форматі p7s)',
  'Document has been signed successfully': 'Документ успішно підписано!',
  'Documents has been signed successfully': 'Документи успішно підписано!',
  'Document date': 'Дата документа',
  'Document author': 'Завантажив/ла',
  'Uploaded by': 'Завантажив',
  Signs: 'Підписи',
  'Sign date': 'Дата підпису',
  Inbox: 'Вхідні',
  Outbox: 'Вихідні',
  'Outbox documents': 'Вихідні документи',
  'Items per page:': 'Кількість записів на сторінці:',
  Choosen: 'Обрано',
  'Documents list': 'Список документів',
  'EDS key': 'Ключ ЕЦП',
  'Mass documents sign': 'Масове підписання документів',
  Signing: 'Підписання',
  'Signing in the process': 'Підписується',
  'Stop sign': 'Перервати підписання',
  'Sign document with EDS key': 'Підпишіть документ за допомогою ЕЦП',
  'Skip sign': 'Пропустити підписання',
  Skipped: 'Пропущено',
  Scope: 'Всі документи',
  Internal: 'Внутрішні',
  External: 'Зовнішні',
  '{0}-{1} of {2}': '{0}-{1} з {2}',
  'You are successfully authorized!': 'Ви успішно авторизовані!',
  'You are successfully registered!': 'Ви успішно зареєстровані!',
  'For print': 'Для друку',
  'For print (with signature protocol)': 'Для друку (З протоколом підписання)',
  'Awaits signing': 'Очікує на підписання',
  'Enter the details of the organization/individual to whom you want to send the document':
    'Вкажіть дані організації/фізичної особи, якій ви хочете надіслати документ',
  'Full name': 'ПІБ',
  'Email (login)': 'Email (логін)',
  'Enter full name': 'Введіть ПІБ',
  'Change full name': 'Змінити ПІБ',
  'Password are successfully updated': 'Пароль успішно змінено',
  'Full name are successfully updated': 'ПІБ успішно змінено',
  'You always can change full name in "Settings"': 'Ви завжди можете змінити ПІБ у "Налаштуваннях"',
  'You always can change password in "Settings"':
    'Ви завжди можете змінити пароль у "Налаштуваннях"',
  'Change password': 'Зміна пароля',
  'Current password': 'Старий пароль',
  'New password': 'Новий пароль',
  'Incorrect current password.': 'Невірний поточний пароль.',
  'My account': 'Мій акаунт',
  'Inner document - you have access to all organizations of document':
    'Внутрішній документ - ви маєте доступ до всіх організацій-сторін даного документу',
  Next: 'Далі',
  'Document loading...': 'Завантаження документа...',
  'Access Denied.': 'Відмовлено в доступі',
  'Setting of password': 'Встановлення пароля',
  'Resetting of password': 'Відновлення паролю',
  Restore: 'Відновити',
  Cancel: 'Скасувати',
  'Organization has been added successfully': 'Організацію успішно додано!',
  'Organization already exists': 'Організація вже існує',
  'This organization was created by another account': 'Цю організацію вже створено іншим акаунтом',
  'Owner email': 'Email власника',
  'You can send a request to join this organization':
    'Ви можете надіслати запит на приєднання до цієї організації',
  'Select your role in organization': 'Оберіть вашу роль в організації',
  'Send request to owner': 'Надіслати запит власнику',
  'Request sent': 'Запит надіслано',
  'Your request has been sent to the organization owner. You will receive an email notification once the owner makes a decision.':
    'Ваш запит надіслано власнику організації. Ви отримаєте повідомлення на email після прийняття рішення власником.',
  'Your join request has been sent successfully': 'Ваш запит на приєднання успішно надіслано',
  'To have access for the document, you should register at first':
    'Для того, щоб переглянути документ, вам потрібно зареєструватися',
  'No items were found': 'Нічого не знайдено',
  'Add organization with EDS key': 'Додати організацію через ЕЦП ключ',
  'To add organization, select EDS key of organization and sign with it':
    'Щоб додати організацію, виберіть файл ЕЦП ключа організації, яку ви хочете додати, та підпишіть його',
  Exit: 'Вихід',
  Filter: 'Фільтр',
  Filters: 'Фільтри',
  'Clear all': 'Очистити все',
  Expand: 'Розгорнути',
  Collapse: 'Згорнути',
  Apply: 'Застосувати',
  'There are no signs': 'Підписів немає',
  'Sign document and connect to us':
    'Підпишіть документ і приєднайтеся до нашої спільної ініціативи',
  Actions: 'Дії',
  Save: 'Зберегти',
  'Document has been successfully signed': 'Документ успішно підписаний',
  'Please use the EDS key instead of seal': 'Будь ласка, використайте ключ ЕЦП замість печатки',
  'Login or registration': 'Вхід або реєстрація',
  'For sign in enter your email': 'Для входу введіть свою e-mail адресу',
  'Digitalized document management service from checkbox':
    'Сервіс електронного документообігу від checkbox',
  'The easiest way to sign and share document':
    'Найпростіший спосіб підписати та поділитися документом',
  'Enter e-mail': 'Введіть e-mail',
  'Approve who you are': 'Підтвердіть, що це Ви',
  'Approval code will come to': 'Код підтвердження прийде на електронну адресу',
  'Change e-mail': '← Змінити e-mail адресу',
  'Approval code': 'Код підтвердження',
  'Send code again': 'Вислати код ще раз',
  'Ask code again': 'Запросити код ще раз',
  Sender: 'Відправник',
  Recipient: 'Отримувач',
  Approve: 'Погодження',
  'Add code EDRPOU': 'Додати код ЄДРПОУ',
  'Extended settings': 'Розширені налаштування',
  'Add one more recipient': 'Додати ще отримувача',
  'What have to do': 'Що має зробити',
  'New document creation': 'Створення нового документа',
  'Send without signing': 'Надіслати без підпису',
  'Document has been successfully signed and sent': 'Документ успішно підписано та надіслано',
  'All participants of the agreement will receive a notification by mail about the need to process the document. As soon as they perform actions with the document, you will instantly receive a notification in the mail.':
    'Всім учасникам підписання прийде повідомлення на пошту про необхідність опрацювати документ. Як тільки вони виконають дії з документом, ви миттєво отримаєте повідомлення на пошту.',
  'Getting to know the platform': 'Знайомство з платформою',
  Skip: 'Пропустити',
  'Send your first document': 'Відправити перший документ',
  'Create your organization': 'Створити свою організацію',
  'Invite colleagues for work': 'Запросити колег до роботи',
  'Invite colleagues': 'Запросити колег',
  'Our service is simple, you have done 1 out of 3 main steps, add organization':
    'Ми настільки прості, що ви вже зробили 1 із 3 основних кроків, додайте організацію',
  'Our service is simple, you have done 2 out of 3 main steps, only invite colleagues left':
    'Ми настільки прості, що ви вже зробили 2 із 3 основних кроків, залишилось запросити колег до роботи',
  'Specify the colleagues from whom you need to get approval':
    'Вкажіть колег від яких потрібно отримати погодження',
  'Document has been successfully sent on approve': 'Документ успішно надіслано на погодження',
  'The sender will receive a message that you have sent the document for approval. In order for the document to be saved and available for you to view, we recommend creating an account, it will take 30 seconds':
    'Відправнику прийде повідомлення про те, що ви відправили документ на погодження. Щоб документ зберігся та був доступний вам до перегляду - рекомендуємо створити акаунт, це займе 30 секунд',
  'The sender will receive a message that you have signed the document. In order for the document to be saved and available for you to view, we recommend creating an account, it will take 30 seconds':
    'Відправнику прийде повідомлення про те, що ви підписали документ. Щоб документ зберігся та був доступний вам до перегляду - рекомендуємо створити акаунт, це займе 30 секунд',
  'Send on approve': 'Надіслати на погодження',
  'Send on sign': 'Надіслати на підпис',
  'Send on view': 'Надіслати на перегляд',
  'Send on fill': 'Надіслати на заповнення',
  'All participants will receive a notification by mail about the need to process the document. As soon as they perform actions with the document, you will instantly receive a notification in the mail.':
    'Всім учасникам прийде повідомлення на пошту про необхідність опрацювати документ. Як тільки вони виконають дії з документом, ви миттєво отримаєте повідомлення на пошту.',
  'Document has been successfully sent': 'Документ успішно надіслано',
  'All participants will receive a notification by mail about the need to process the document. As soon as they take action on the document, we will notify you instantly.':
    'Всім учасникам прийде на пошту повідомлення про необхідність опрацювання документа. Як тільки вони виконають дії з документом, ми миттєво повідомимо вас.',
  'Add colleagues': 'Додати колег',
  'Create organization': 'Створити організацію',
  'Create account': 'Створити акаунт',
  'Easy start': 'Легкий Старт',
  'Add organization and sign documents instantly':
    'Додайте організацію та починайте підписувати документи миттєво',
  'Your document has already been sent for approval and is now waiting for approval by all participants.':
    'Ваш документ вже відправлено на погодження і тепер чекає на узгодження всіма учасниками.',
  'Sign document': 'Підписати документ',
  'Approval route': 'Маршрут погодження',
  'Reject document': 'Відхилити документ',
  'Approve document': 'Погодити документ',
  'Document has been successfully approved': 'Документ успішно погоджено',
  'The sender will receive a message that you have approved the document. In order for the document to be saved and available for you to view, we recommend creating an account, it will take 30 seconds':
    'Відправнику прийде повідомлення про те, що ви погодили документ. Щоб документ зберігся та був доступний вам до перегляду - рекомендуємо створити акаунт, це займе 30 секунд',
  Signed: 'Підписано',
  Approved: 'Погоджено',
  Rejected: 'Відхилено',
  'Are you sure you want to reject the document?': 'Ви дійсно хочете відхилити документ?',
  'This comment will only be available to those who will receive this document':
    'Цей коментар буде доступний тільки для тих, хто отримає цей документ',
  'Yes, reject': 'Так, відхилити',
  'Enter reason of document reject': 'Вкажіть причину відхилення документа',
  'Reason of document reject': 'Причина відхилення документу',
  'Document has been successfully rejected': 'Документ успішно відхилено',
  'The sender will receive a message that you have rejected the document and the reason for rejection. In order for the document to be saved and available for you to view, we recommend creating an account, it will take 30 seconds':
    'Відправнику прийде повідомлення про те, що ви відхилили документ та причину відхилення. Щоб документ зберігся та був доступний вам до перегляду - рекомендуємо створити акаунт, це займе 30 секунд',
  'Document route': ' Маршрут документа',
  'Document details': 'Деталі документа',
  Type: 'Тип',
  'Document amount': 'Сума документа',
  View: 'Перегляд',
  'To view': 'Переглядати',
  Viewed: 'Переглянуто',
  'Have a look': 'Переглянути',
  'New document': 'Новий документ',
  Number: 'Номер',
  Status: 'Статус',
  'All statuses': 'Всі статуси',
  'Users have been sent a confirmation email':
    'Користувачам надіслано листа на пошту для підтвердження',
  contractors: 'контрагенти',
  documentType: 'типи',
  'Rows per page': 'Кількість записів на сторінці',
  'Indicated everything correctly': 'Вказав все вірно',
  'We recommend first agreeing on the document and then signing it':
    'Рекомендуємо спершу погодити документ, а потім підписувати',
  'To ensure that all parties agree to its content and terms. Agreement before signing allows you to ensure mutual understanding between all participants in the process and avoid misunderstandings after signing the document.':
    'Щоб упевнитися, що всі сторони згодні з його вмістом та умовами. Погодження перед підписанням дозволяє забезпечити взаєморозуміння між всіма учасниками процесу та уникнути недорозумінь після підписання документа.',
  'Send document': 'Відправити документ',
  'Sign your first document': 'Підписати перший документ',
  'Your request to organization has been successfully accepted':
    'Ви успішно приєдналися до організації',
  Auth: 'Авторизація',
  'Document has been deleted successfully': 'Документ успішно видалено',
  'We could not read the key data. Please try again or choose a different key':
    'Ми не змогли зчитати дані ключа. Будь ласка, спробуйте ще раз або оберіть інший ключ',
  'The USREOU codes do not match. Please choose another':
    'Коди ЄДРПОУ не співпадають. Оберіть інший ключ',
  signPlugin: {
    signDocument: 'Підпис документа',
    signAct: 'Підпис акту',
    signDocuments: 'Підпис документів',
    sync: '<p>Щоб синхронізувати дані з ДПС, потрібно підписати запит ключем ЕЦП</p><p>Ви можете зробити це декількома способами: за допомогою файлового ключа ЕЦП або через SmartID</p>',
    syncDataWithSfs: 'Синхронізувати дані з ДПС',
    directorSign:
      'Це вікно використовується для накладання підпису ФОП/директора ТОВ, власника акаунту Checkbox',
    smartId:
      '<p>Натисність або зчитайте QR-код сканером у застосунку Приват24 та дотримуйтесь інструкцій</p><p>Зверніть увагу, що сканування QR-коду відбуваєтсья декілька разів</p>',
    addOrg: 'Додати організацію',
    signWith: 'Підписати через'
  },
  Confirm: 'Підтвердити',
  RNOCPP: 'РНОКПП',
  Certificates: 'Сертифікати',
  'EDS (DSTU 4145)': 'ЕЦП (ДСТУ 4145)',
  'Key distribution protocols (DSTU 4145)': 'Протоколи розподілу ключів (ДСТУ 4145)',
  'The certificate issued': 'Сертифікат виданий',
  'Serial number': 'Серійний номер',
  'The certificate is valid': 'Сертифікат чинний',
  from: 'з',
  to: 'до',
  Profile: 'Профіль',
  'Document has been sent on approvals successfully': 'Документ успішно надісланий на погодження',
  'Possible formats: *.dat, *.pfx, *.pk8, *.zs2, *.jks':
    'Формати key-6.dat, *.pfx, *.pk8, *.zs2, *.jks',
  'Document has been sent successfully': 'Документ успішно надіслано наступну учаснику маршруту',
  'Route has been edited and document has been sent': 'Маршрут відредаговано та документ надіслано',
  'The document will be signed by you and sent to all participants in the process':
    'Документ буде підписаний вами та відправлений усім учасникам процесу',
  'I approve the document and hand it over to the owner for signature':
    'Документ погоджую та передаю на підпис власнику',
  'The document will be rejected and sent to the owner for editing':
    'Документ буде відхилено та передано власнику на редагування',
  'The document needs a preliminary one agreement before signing':
    'Документ потребує попереднього узгодження перед підписанням',
  'Documents will be sent according to the specified route':
    'Документи буде відправлено згідно заданому маршруту',
  Understand: 'Зрозуміло',
  'Date uploading': 'Дата завантаження',
  'Start work with Dubidoc': 'Початок роботи з Dubidoc',
  'Upload document': 'Завантажте документ',
  '(PDF, DOCX, JPG etc)': '(PDF, DOCX, JPG тощо)',
  'Sign it': 'Підпишіть його',
  '(via Diia or via other KEP)': '(за допомогою Дія або іншого КЕП)',
  'Share with others': 'Поділіться з іншими',
  '(link or via mail)': '(посилання або на пошту)',
  Welcome: 'Вітаємо',
  Edit: 'Редагувати',
  Share: 'Поділитися',
  'Go back': 'Назад',
  'Share this document': 'Поділіться цим документом',
  // routes modal
  'Route details': 'Деталі маршруту',
  Approver: 'Погоджувач',
  'Unknown user': 'Невідомий користувач',
  Use: 'Використати',
  'You will send email with link to this document':
    'Ви надішлете електронний лист із посиланням на цей документ',
  'Users with access': 'Користувачі, що мають доступ',
  You: 'Ви',
  'Public access': 'Загальний доступ',
  'Anybody with document link': 'Користувачі інтернету, які мають це посилання',
  'Add users email': 'Додайте e-mail користувачів',
  Ready: 'Готово',
  'Copy link': 'Копіювати посилання',
  'Send link': 'Надіслати посилання',
  'My data': 'Мої дані',
  'Welcome to Dubidoc': 'Ласкаво просимо в Dubidoc',
  'Upload your first document': 'Завантажте свій перший документ',
  '{document} has been successfully uploaded': '{document} успішно завантажено',
  'Add new organization': 'Додати нову організацію',
  'Document title has successfully changed': 'Назву документа успішно змінено',
  'Template title has successfully changed': 'Назву шаблону успішно змінено',
  'Document has successfully archived': 'Документ успішно заархівовано',
  'Documents have successfully archived': 'Документи успішно заархівовано',
  'Archive document': 'Перенести в Архів',
  'Archive documents': 'Перенести в Архів',
  'This email is already taken': 'E-mail вже використовується',
  'This edrpou is already taken': 'ЄДРПОУ вже використовується',
  'No created organizations': 'Немає створених організацій',
  'Create your first organization to organize better your documents':
    'Створіть свою першу організацію, щоб краще організувати та керувати вашими документами',
  'More details': 'Детальніше',
  'New user': 'Новий користувач',
  'New organization': 'Нова організація',
  'Copied to clipboard': 'Скопійовано в буфер обміну',
  'Changes saved successfully': 'Зміни успішно збережено',
  'Participant has successfully deleted': 'Учасника документа успішно видалено',
  'New version available': 'Доступна нова версія',
  'This page could not be found':
    'Вибачте, але сторінку не знайдено. Будь ласка, поверніться на головну сторінку.',
  'Come back to main page': 'Повернутися на головну',
  'Move to archive': 'Перенести в архів',
  'Move to documents': 'Перенести до документів',
  'Document has successfully unarchived':
    'Документ успішно перенесено до всіх загального списку документів',
  'Documents have successfully unarchived':
    'Документи успішно перенесено до всіх загального списку документів',
  Refresh: 'Оновити',
  'Error occurred. Try again later or contact with administrator':
    "Сталася помилка. Спробуйте пізніше або зв'яжіться з адміністратором",
  'Document has been signed': 'Документ підписано',
  'The sender will receive a message that you have signed the document. To start working with documents in the Dubidoc service, we recommend creating an account, it takes 30 seconds.':
    'Відправнику прийде повідомлення про те, що ви підписали документ. Щоб почати роботу з документами в сервісі Dubidoc - рекомендуємо створити акаунт, це займе 30 секунд.',
  'Create an account': 'Створити акаунт',
  'Name has been changed successfully': 'ПІБ успішно змінено',
  'Enter your colleagues` email and assign them a role, and we`ll send a message telling them what to do next. You can always change access in the settings section':
    'Вкажіть електронну пошту своїх колег та задайте їм роль, а ми надішлемо повідомлення і розповімо, що їм робити далі. Доступи ви завжди можете змінити у розділі “Користувачі”',
  Email: 'Електронна адреса',
  'Role in system': 'Роль в системі',
  'Send messages': 'Надіслати повідомлення',
  'Add one more user': 'Додати ще користувача',
  'Auth token is outdated. Renew Please': 'Для доступу до документу необхідно авторизуватись',
  'Error occurred with {document} - {error}': '{document} не завантажено, виникла помилка: {error}',
  Ok: 'Добре',
  'All the documents you sent to the Archive are stored here (they are not deleted)':
    'Тут зберігаються усі документи, які ви переслали в Архів (вони не видаляються)',
  'You (Owner)': 'Ви (Власник)',
  Copy: 'Копіювати',
  'Who can open document': 'Хто може відкривати документ',
  'User can': 'Користувач може',
  'Can sign': 'Може підписувати',
  'Can view': 'Може переглядати',
  'Everyone, who has link': 'Усі, хто мають посилання',
  'Private access': 'Обмежений доступ',
  'Only users with access to open this document':
    'Лише користувачі з доступом можуть переходити за цим посиланням',
  Rename: 'Перейменувати',
  'Signatures and access': 'Підписи та доступи',
  'Document title must be minimum 3 characters':
    'Назва документа повинна бути не менше 3-ох символів',
  'Template title must be minimum 3 characters':
    'Назва шаблону повинна бути не менше 3-ох символів',
  'Add user email or EDRPOU and click +': 'Додайте E-mail або ЄДРПОУ отримувача та натисніть +',
  'Current function is at development stage': 'Дана функція знаходиться на етапі розробки',
  Tags: 'Мітки',
  'New tag': 'Нова мітка',
  'Help organize documents by providing a convenient way to quickly find, sort and use them':
    'Допомагають організувати документи, забезпечуючи зручний спосіб їх швидкого пошуку, сортування та використання',
  'Enter name of new tag': 'Введіть назву нової мітки',
  'Choose tag color': 'Оберіть колір мітки',
  Create: 'Створити',
  'Tag edit': 'Редагування мітки',
  'Remove tag': 'Вилучити мітку',
  'Documents are labeled by this tag {tagName} will not deleted':
    'Документи, які були відмічені цією міткою "{tagName}", не видаляються',
  'Tag {tagName} has added to document': 'Мітку "{tagName}" додано до документу',
  'Tag {tagName} has deleted from document': 'Мітку "{tagName}" було видалено із документу',
  'Add tag': 'Додати мітку',
  'Tag {tagName} has added to documents': 'Мітку "{tagName}" додано до документів',
  'All the documents you tagged to the Archive are stored here':
    'Тут зберігаються усі документи помічені міткою "{tagName}"',
  'Tag name': 'Назва мітки',
  'Tag color': 'Колір мітки',
  'Access to document': 'Доступ до документу',
  'API key': 'API ключ',
  'Create API key': 'Створіть API ключ',
  'To integrate Dubidoc into other systems': 'Щоб інтегрувати сервіс Dubidoc з іншими системами',
  'Create new key': 'Створити новий ключ',
  'New key': 'Новий ключ',
  'Generated API key': 'Згенерований ключ API',
  'Title edit': 'Редагування назви',
  'Enter key name (not required)': 'Вкажіть назву ключа (не обовʼязково)',
  'Managing key, you set an integration':
    'Цей ключ можна використовувати для налаштування інтеграції',
  'Generated API key copied': 'Згенерований ключ API скопійований',
  'Secret key': 'Секретний ключ',
  'API key copied': 'Ключ API скопійований',
  'API key created': 'API ключ створено',
  'Create key': 'Створити ключ',
  'Revoke key': 'Вилучити ключ',
  'Delete key': 'Видалити ключ',
  'Organization ID': 'ID організації',
  'Organization ID copied': 'ID організації скопійовано',
  'This API key will be disabled immediately. APl requests made using this key will be rejected. Once revoked, you will no longer be able to view or change this API key':
    'Цей ключ API буде автоматично вимкнено. Запити APl, зроблені за допомогою цього ключа буде відхилено. Після відкликання ви більше не можете переглядати чи змінювати цей ключ API',
  'Edit name': 'Редагувати назву',
  Display: 'Відобразити',
  Show: 'Показати',
  Hide: 'Сховати',
  'In documents list': 'У списку документів',
  'To many requests!': 'Забагато запитів!',
  'List of documents for signature': 'Перелік документів для підпису',
  'Documents signed': 'Документи підписано',
  'The process completed with some errors. Please check the indicated errors and try to sign these documents again':
    'Процес завершено з деякими помилками. Перевірте вказані помилки та спробуйте підписати ці документи ще раз',
  'All selected documents were successfully signed': 'Всі обрані документи були успішно підписані',
  'Error occurred while signing': 'Виникла помилка при спробі підпису',
  'Signed before': 'Підписано раніше',
  'Document has signed already': 'Документ було підписано раніше',
  'Current organization': 'Поточна організація',
  'New users': 'Нові користувачі',
  'Send emails about documents': 'Надсилати повідомлення про документи',
  'Enter user email or EDRPOU': 'Введіть E-mail або ЄДРПОУ отримувача',
  Notifications: 'Повідомлення',
  Get: 'Отримувати',
  'Do not get': 'Не отримувати',
  'Documents to the email': 'Документи на пошту',
  'Change user role': 'Зміна ролі користувача',
  'You are going to change the role of the selected user in the system. The selected role will determine the level of access and user capabilities in the system':
    'Ви збираєтеся змінити роль обраного користувача в системі. Вибрана роль визначатиме рівень доступу та можливості користувача в системі',
  'User role has been changed': 'Роль користувача змінено',
  'Documents notifications disabled': 'Повідомлення про документи “Вимкнено”',
  'Documents notifications enabled': 'Повідомлення про документи “Увімкнено”',
  'Enter value': 'Введіть значення',
  'E-stamp': 'Електронна печатка',
  Text: 'Текст',
  'Select date': 'Оберіть дату',
  Templates: 'Шаблони',
  'Documents search': 'Пошук документів',
  Search: 'Пошук',
  'Create document': 'Створити документ',
  'Save changes': 'Зберегти зміни',
  'Changes have successfully saved': 'Зміни успішно збережено',
  'Delete template': 'Видалити шаблон',
  'Are you sure to delete this template?': 'Ви дійсно бажаєте видалити даний шаблон?',
  Yes: 'Так',
  No: 'Ні',
  'Template has deleted successfully': 'Шаблон успішно видалено',
  'Save your time with templates': 'Економте час з шаблонами',
  'Document not found': 'Документ не знайдено',
  'Save the created templates for quick use with other recipients':
    'Зберігайте створені шаблони для швидкого використання з іншими отримувачами',
  Checkbox: 'Галочка',
  Checkboxes: 'Галочки',
  'Please fill {count} required fields': "Будь ласка, заповніть {count} обов'язкових поля",
  Fill: 'Заповнити',
  Filling: 'Заповнення',
  Finish: 'Завершити',
  'Document has created successfully by template': 'Документ успішно створений на основі шаблону',
  'Changes have successfully saved into template': 'Зміни у шаблоні збережено',
  'Select variant from list': 'Оберіть варіант зі списку',
  'Dropdown list': 'Випадаючий список',
  'Add variant': 'Додати варіант',
  'E-signature': 'Електронний підпис',
  'Private documents': 'Особисті документи',
  'ALL ORGANIZATIONS': 'ВСІ ОРГАНІЗАЦІЇ',
  'Send document to E-mail': 'Надішліть документ на E-mail',
  'This organization is not yet registered in Dubidoc, we recommend sending the document to E-mail':
    'Ця організація ще не зареєстрована в Dubidoc, рекомендуємо відправити документ на E-mail',
  'Diia.Sign': 'Дія.Підпис',
  monoKEP: 'monoKEП',
  'Read the key through monoKEP': 'Прочитати ключ через monoKEП',
  'Sign via monoKEP': 'Підпис через monoKEП',
  'Scan QR-code and follow instructions in monobank app':
    'Відскануйте QR-код та дотримуйтесь інструкцій в застосунку monobank',
  'Recommendation: after signing in monobank app come back to document page and wait for signature apply':
    'Рекомендація: після підписання в застосунку monobank поверніться на сторінку документа та дочекайтеся застосування підпису',
  'Open Privat': 'Відкрити Приват',
  'Sign with Privat': 'Підписати через Приват',
  Step: 'Крок',
  'Scan QR-code and follow instructions in Diia app':
    'Відскануйте QR-код сканером у застосунку Дія та дотримуйтесь Інструкцій',
  'To sign the document, you need to log in to the Privat24 application':
    'Для підписання документа треба авторизуватися в застосунку Приват24',
  'None of the participants have signed the document yet':
    'Ще ніхто з учасників не підписав документу',
  'About us': 'Про нас',
  'Join us in Facebook': 'Приєднуйся до нас у Facebook',
  'Join us in Instagram': 'Слідкуйте за нами в Instagram',
  'Our news in Telegram': 'Наші новини в Telegram',
  'Watch us in Youtube': 'Дивіться нас на YouTube',
  'Join us in Linkedin': 'Приєднуйся до LinkedIn',
  'Our apps': 'Наші застосунки',
  'Download iOS app': 'Встановити застосунок iOS',
  'Download Android app': 'Встановити застосунок Android',
  'Share these documents': 'Поділіться цими документами',
  'Add participant': 'Додати отримувача',
  'Email or Edprou': 'E-mail або ЄДРПОУ',
  'Documents have successfully sent': 'Документи було успішно надіслано',
  'Delete organization': 'Видалення організації',
  'All documents connected with organization will be deleted':
    'Всі документи, пов’язані з цією організацією, будуть безповоротно видалені',
  'The organization will be deleted at 11:59 p.m. the same day if you delete it before 6:00 p.m., or at 11:59 p.m. the next day if after 6:00 p.m.':
    'Організація буде видалена о 23:59 того ж дня, якщо ви її видалите до 18:00, або о 23:59 наступного дня, якщо після 18:00',
  'Export documents before deletion': 'Експортувати документи перед видаленням',
  Export: 'Експортувати',
  'Export completed successfully': 'Експорт завершено успішно',
  'Confirm delete': 'Підтвердити видалення',
  'Organization on a delete process': 'Організація на видаленні',
  'Your organization and all related documents are currently in the "For deletion" status. You can undelete to regain full access to the organization and its documents':
    'Ваша організація та всі пов’язані з нею документи наразі знаходяться у статусі “На видаленні”. Ви можете скасувати видалення, щоб відновити повний доступ до організації та її документів',
  'On delete': 'На видаленні',
  cancel: 'Відмінити',
  'Organization delete canceled': 'Видалення організації скасовано',
  'Undo The organization and all related documents have been successfully restored. You have full access to the organization and its documents again':
    'Організацію та всі пов’язані з нею документи успішно відновлено. Ви знову маєте доступ до організації та її документів у повному обсязі',
  'Cancel delete': 'Скасувати видалення',
  'This role does not allow to view organization`s documents':
    'Ця роль не передбачає перегляд документів організації',
  'To fill': 'Заповнити',
  'Public template': 'Публічний шаблон',
  'Clients fill template by themself and you get prepared document':
    'Клієнти самі заповнюють шаблон, а ви отримуєте готовий документ',
  'Scan quickly and conveniently': 'Скануй швидко та зручно',
  'Share link or QR-code': 'Діліться посиланням або QR–кодом',
  'Get filled documents without any time loses!':
    'Отримуйте заповнені документи без зайвих витрат часу!',
  'Download QR-code': 'Завантажити QR-код',
  'Link copied': 'Посилання скопійоване',
  'Failed to create QR-code': 'Не вдалося створити QR-код',
  'Failed to load image': 'Не вдалося завантажити зображення',
  'Finish filling': 'Завершити заповнення',
  'Template has successfully filled': 'Шаблон успішно заповнено',
  'Add minimum 2 variants': 'Додайте мінімум 2 варіанти',
  'Work start': 'Початок роботи',
  'Upload file': 'Завантажте файл',
  'Add dynamic fields': 'Додайте динамічні поля',
  'which will be available for filling': 'які будуть доступні для заповнення',
  'Generate document': 'Створіть документ',
  'and share it via email, link or QR-code': 'Та ділитися через email, посилання або QR-код',
  'How it works': 'Як це працює',
  'Hi {name}': 'Привіт {name} 👋🏼',
  'Templates gives opportunity to create interactive documents, send them, fill and sign':
    'Шаблони дають змогу створювати інтерактивні документи, надсилати їх іншим для заповнення та підписання',
  'This could be a contract, application, or any other document you want to automate':
    'Це може бути договір, заявка або будь-який інший документ, створення якого ви хочете автоматизувати',
  'Setup dynamic fields': 'Налаштуйте динамічні поля',
  'Allow recipients to fill out the document exactly as needed':
    'Це дозволить отримувачам заповнити документ згідно з вашими налаштуваннями',
  'Send template': 'Діліться документами',
  'Share a public template via link or QR code. The template is always saved in your account':
    'Створюйте документи на основі шаблонів або робіть їх публічними через посилання чи QR-код, щоб отримувати заповнені й підписані документи',
  Try: 'Спробувати',
  'All fields are required to be valid': 'Всі поля повинні бути валідними',
  'To sign a document, you must first fill in all the dynamic fields. This can be done by either you or the recipient':
    'Щоб підписати документ, потрібно спочатку заповнити всі динамічні поля. Це може зробити як ви, так і отримувач.',
  'Need to fill all fields': 'Необхідно заповнити усі поля',
  'Recommendation: after signing in Diia app come back to document page and wait for signature apply':
    'Рекомендація: після підписання в застосунку "Дія" поверніться на сторінку документа та дочекайтесь відображення підпису',
  'Create template': 'Створіть шаблон',
  'Drag files here': 'Перетягніть файли сюди',
  'Supported formats:': 'Підтримуємо формати:',
  'Choose file': 'Виберіть файл',
  'Choose files': 'Виберіть файли',
  'Upload error': 'Помилка завантаження',
  'Unfortunately, we do not support this document type, or an unexpected error occurred':
    'На жаль, ми не підтримуємо цей тип документа, або сталася неочікувана помилка',
  'Loading..': 'Завантаження..',
  filesCounter: {
    lessThanFour: 'файли',
    moreThanFour: 'файлів'
  },
  'Template uploader': 'Заватаження шаблону',
  Recommended: 'Рекомендовані',
  'Templates gallery': 'Галерея шаблонів',
  'Create or select ready template': 'Створіть або оберіть готовий шаблон',
  'New template': 'Новий шаблон',
  Select: 'Обрати',
  'Numeric field': 'Числове поле',
  Formula: 'Формула',
  Numeric: 'Число',
  Sum: 'Сума',
  'Select formula': 'Оберіть формулу',
  'Before adding "Formula" you should have at least one "Numeric field"':
    'Щоб додати поле "Формула" потрібно хоча б одне "Числове поле"',
  'Formula should have at least one operand': 'Формула повинна містити хоча б одне "Числове поле"',
  'Choose a calculation formula': 'Оберіть формулу обчислення',
  'Refresh field': 'Очистити поле',
  'Add and sign': 'Додати та підписати',
  'Electronic ink signature': 'Електронно-чорнильний підпис',
  'Convert to PDF': 'Конвертувати в PDF',
  'Document has converted to PDF': 'Документ конвертовано в PDF',
  'By signing this document electronically, I agree that my signature and initials are the equivalent of my handwritten signature and are considered originals on all documents, including legally binding contracts.':
    "Підписуючи цей документ в електронному вигляді, я погоджуюся з тим, що мій підпис та ініціали є еквівалентом мого рукописного підпису і вважаються оригіналами на всіх документах, включаючи юридично обов'язкові контракти.",
  'Quick fill': 'Швидке заповнення',
  'Fill documents dynamic fields in simplified form':
    'Заповніть доступні динамічні поля документа у спрощеній формі',
  'Documents not signed': 'Документи не підписано',
  'Average value': 'Середнє значення',
  'Delete document': 'Видалити документ',
  'Document will be deleted. Are you sure you want to delete it?':
    'Документ буде безповоротно видалено. Ви впевнені що хочете видалити документ?',
  'API key has been successfully deleted': 'API ключ успішно видалено',
  'Tag has been successfully deleted': 'Тег успішно видалено',
  "You already downloaded the director's EDS signature as part of the session, so we took it from the cache. Wait for the operation to complete":
    'Ви вже завантажували підпис ЕЦП директора в рамках сесії, тому ми взяли його з кешу. Очікуйте завершення операції',
  'Type of private key carrier': 'Тип носія особистого ключа',
  'File carrier': 'Файловий носій',
  'flash disk, CD disk, SD card, etc': 'flash-диск, CD-диск, SD-карта тощо',
  'Protected carriers': 'Захищені носії',
  'electronic key Almaz-1K, Crystal-1, Hryada-301, ID card, etc':
    'е.ключ Алмаз-1К, Кристал-1, Гряда-301, ID-карта тощо',
  'Type of signature service': 'Тип сервісу підпису',
  'EDS service provider': 'Надавач послуги ЕЦП',
  'Personal key carrier': 'Носій особистого ключа',
  'Key protection password': 'Пароль захисту ключа',
  'Read key': 'Зчитати ключ',
  'Signature of the request to the DPS': 'Підпис запиту до ДПС',
  'Read the key via SmartID': 'Зчитати ключ через SmartID',
  'Signature via SmartID': 'Підпис через SmartID',
  'Read the key through Diia.Signature': 'Зчитати ключ через Дія.Підпис',
  'Signature via Diia.Signature': 'Підпис через Дія.Підпис',
  'EDS file key': 'Файловий ключ ЕЦП',
  'Check the read key information': 'Перевірте інформацію про зчитаний ключ',
  'Determine automatically': 'Визначити автоматично',
  'File is too large to be processed. Please select another file':
    'Розмір файлу занадто великий для обробки. Оберіть інший файл',
  'An error occurred while processing the file': 'Під час обробки файлу сталася помилка',
  'The web signature library is not supported by your browser or OS':
    'Бібліотека web-підпису не підтримується в вашому браузері або ОС',
  link: 'посиланням',
  'The web signature library requires the web extension to be installed. Please install the web extension by':
    'Бібліотека web-підпису потребує встановлення web-розширення. Будь ласка, встановіть web-розширення за',
  'The web signature library needs updating. Please install the update by':
    'Бібліотека web-підпису потребує оновлення. Будь ласка, встановіть оновлення за посиланням',
  'and refresh the page': 'та оновіть сторінку',
  'The web signature library needs to be installed. Please install the library by':
    'Бібліотека web-підпису потребує встановлення. Будь ласка, встановіть бібліотеку за',
  'Add field': 'Додати поле',
  'Field name': 'Назва поля',
  'Field comment': 'Коментар до поля',
  'Recipient`s email or EDRPOU': 'E-mail або ЄДРПОУ отримувача',
  'To approve': 'Погодити',
  'We recommend': 'Рекомендуємо',
  'First approve document, then sign it. This will ensure that all parties agree to its content and terms':
    'Спочатку погодити документ, а потім його підписувати. Це дозволить переконатися, що всі сторони згодні з його вмістом та умовами',
  Route: 'Маршрут',
  Detail: 'Деталі',
  'Sum, uah': 'Сума, грн',
  'Document has not signed yet': 'Документ ще не підписаний',
  'Show sidebar': 'Показати сайдбар',
  'Hide sidebar': 'Сховати сайдбар',
  'Edit document': 'Редагування документу',
  'Please provide a reason for rejecting the document. This comment will only be visible to the owner':
    'Вкажіть причину відхилення документа. Цей коментар буде доступний тільки для власника',
  'Document has approved': 'Документ погоджено',
  'You have successfully approved the document. It will now be forwarded to the next stage or for signature by other participants, according to the sender`s chosen route. To save this document to your personal account, please log in to your account or register':
    'Ви успішно погодили документ. Тепер він буде переданий на наступний етап або на підписання іншим учасникам, згідно з обраним маршрутом відправника. Щоб зберегти цей документ у вашому особистому кабінеті, будь ласка, увійдіть до свого облікового запису або зареєструйтеся',
  'Indicate sequentially the colleagues from whom you need to obtain approval':
    'Вкажіть послідовно колег від яких потрібно отримати погодження',
  'To main page': 'На головну',
  'Enter recipient`s email': 'Вкажіть E-mail отримувача',
  'Document has sent': 'Документ надіслано',
  'The document has been successfully submitted for approval. You will receive a notification once it has been approved and will be able to sign the document':
    'Документ успішно надіслано на погодження. Ви отримаєте повідомлення після його погодження та зможете підписати документ',
  'You are about to send a document for approval. Once the user approves the document, it will automatically be sent for signature to other participants according to the selected route':
    'Ви збираєтеся надіслати документ на погодження. Після того як користувач погодить документ, він автоматично буде відправлений на підпис іншим учасникам згідно з обраним маршрутом',
  'Document has sent on approval': 'Документ надіслано на погодження',
  'The document has been successfully sent for approval to user {username}. After approval, the document will automatically be sent for signature to other participants according to the selected route':
    'Документ успішно відправлено на погодження користувачу {username}. Після погодження документ автоматично буде відправлено на підпис іншим учасникам згідно з обраним маршрутом',
  'You are about to send the document for signature to other participants according to the selected route. After that, they will receive a request to sign the document':
    'Ви збираєтеся надіслати документ на підпис іншим учасникам згідно з обраним маршрутом. Після цього вони отримають запит на підписання документа',
  'Document has sent for sign': 'Документ надіслано на підпис',
  'All participants will receive an email notification that they need to sign the document. As soon as they complete the actions with the document, we will instantly notify you':
    'Всім учасникам прийде на пошту повідомлення про необхідність підписати документ. Як тільки вони виконають дії з документом, ми миттєво повідомимо вас',
  'Document has signed and sent': 'Документ підписано та надіслано',
  'All participants will receive an email regarding the need to process the document. As soon as they complete the necessary steps with the document, you will immediately receive a notification in the mail':
    'Всі учасники отримають лист на електронну пошту щодо необхідності обробки документа. Як тільки вони виконають необхідні кроки з документом, ви одразу ж отримаєте повідомлення на пошту',
  'The sender will receive a notification that you have signed the document':
    'Відправнику прийде повідомлення про те, що ви підписали документ',
  'Document has signed': 'Документ підписано',
  'New folder': 'Нова папка',
  'Use folders for structure documents': 'Використовуйте папки, щоб впорядкувати документи',
  'Folder name': 'Назва папки',
  'Folder “{folderName}” created': 'Папку “{folderName}” створено',
  'Folder has renamed': 'Папку перейменовано',
  'Delete folder?': 'Видалити папку?',
  'When you delete a folder, all documents inside will be deleted':
    'При видаленні папки всі документи, що знаходяться всередині, будуть видалені',
  'Folder has been successfully deleted': 'Папку успішно видалено',
  'Folder is empty': 'Папка порожня',
  'Add documents to this folder for easy storage. You can move documents from the archive here or upload new ones':
    'Додайте документи в цю папку для зручного зберігання. Ви можете перемістити сюди документи з архіву або завантажити нові',
  'Move to folder': 'Перемістити у папку',
  'Add to folder': 'Додати в папку',
  'Select folder for moving documents or create a new one':
    'Оберіть папку для переміщення документа(ів) або створіть нову',
  Register: 'Зареєструватися',
  'Show comments': 'Показати коментарі',
  Comments: 'Коментарі',
  Closed: 'Закриті',
  Opened: 'Відкриті',
  'Write your comment': 'Напишіть свій коментар',
  'Who can see comments': 'Хто може бачити коментарі',
  'All users with rights to comment or edit this document':
    'Усі користувачі з правом коментувати або редагувати цей документ',
  repliesCounter: {
    1: 'відповідь',
    '2-4': 'відповіді',
    '>5': 'відповідей'
  },
  'Reply..': 'Відповісти..',
  'Edit comment': 'Редагувати коментар',
  'Comment resolved and hidden': 'Обговорення вирішене та сховане',
  'Comment has edited successfully': 'Коментар успішно відредаговано',
  'Mark, as resolved': 'Позначити, як вирішений',
  'Event log': 'Журнал подій',
  'The field "Choose EDS key" must have a value': 'Поле "Оберіть ключ ЕЦП" повинно мати значення',
  Mean: 'Середнє значення',
  'Sorry, you have made too many requests in a short time. Please try again in a few minutes':
    'Вибачте, але ви зробили занадто багато запитів за короткий час. Будь ласка, спробуйте ще раз через декілька хвилин.',
  'All documents have been successfully sent except for the instructions below.':
    'Усі документи крім наведених нижче успішно надіслано',
  'Fill and sign': 'Заповнити та підписати',
  'Document has moved to folder {folderName}': 'Документ перенесено до папки "{folderName}"',
  'Documents has moved to folder {folderName}': 'Документи перенесено до папки "{folderName}"',
  Contacts: 'Контакти',
  'Create contact': 'Створити контакт',
  'Add contact': 'Додайте контакти',
  'To automatically update data while creating documents':
    'Для автоматичного заповнення даних під час створення документів',
  'Contact details': 'Контактні дані',
  'PIB or name of organization': 'ПІБ або назва організації',
  'Enter PIB or name of organization': 'Введіть ПІБ або назву організації',
  'Contact created': 'Контакт створено',
  'Contact created description':
    'Контакти дозволяють автоматично заповнювати дані отримувачів під час створення документів',
  'Delete contact': 'Видалити контакт',
  'Delete contact "{name}" description':
    'Ви впевнені, що хочете видалити контакт "{name}"?\n' +
    '\n' +
    '<br /> Цю дію неможливо скасувати, і контакт буде безповоротно видалено з вашої бази',
  'Contact has deleted successfully': 'Контакт успішно видалено',
  'Edit contact': 'Редагувати контакт',
  'Save edited': 'Зберегти зміни',
  Information: 'Інформація',
  'Document has been successfully created': 'Документ успішно створено',
  'Document has been successfully edited': 'Документ успішно відредаговано',
  'Install app': 'Встановлюйте застосунок',
  'Install app description': 'Підписуйте та надсилайте документи прямо зі смартфона (Android, iOS)',
  Install: 'Встановити',
  'Scan QR Code': 'Скануйте QR-код',
  'Scan QR Code description': 'Щоб встановити мобільний застосунок',
  Comment: 'Коментар',
  'It is impossible to add a comment in the closed comments section':
    'Додати коментар в розділі закриті коментарі неможливо',
  'No results found': 'Результатів не знайдено',
  Drop: 'Скинути',
  'Import contacts': 'Імпортувати контакти',
  Import: 'Імпортувати',
  'Use the {formats} formats or our template': 'Використовуйте формати {formats} або наш',
  'Contacts imported': 'Контакти імпортовано',
  'All contacts have been imported into the system. Total number of contacts added: {count}':
    'Всі контакти були імпортовані до системи. Загальна кількість доданих контактів: {count}',
  'Go to contacts': 'Перейти до контактів',
  'When you delete a folder, all documents inside will moved to archive':
    'При видаленні папки всі документи, що знаходяться всередині, будуть перенесені до архіву',
  'Contact has been successfully edited': 'Контакт успішно відредаговано',
  'Successfully imported {successCount} contacts. {errorCount} contacts contained errors and were not added.':
    'Успішно імпортовано {successCount} контактів. {errorCount} контакти містять помилки і не були додані',
  Row: 'Рядок',
  'Description error': 'Опис помилки',
  'Public link': 'Публічне посилання',
  'After document upload you will get chance to generate unique link which you can send to participant':
    'Після завантаження документа ви зможете згенерувати унікальне посилання, яке можна відправити отримувачу',
  'Anyone with the link can': 'Будь-хто, хто має посилання, може',
  'Select action': 'Оберіть дію',
  'Copy public link': 'Скопіювати публічне посилання',
  'Send public link': 'Надіслати публічне посилання',
  'Share via': 'Надіслати через',
  'Share document with you': 'Перегляньте документ у Dubidoc',
  'We will notify you as soon as SMS sharing is available':
    'Ми повідомимо вас, як тільки буде доступний SMS-шаринг',
  'Anyone with the link can sign': 'Будь-хто, хто має посилання, може підписувати',
  'Copy this link and share it with the recipients. Anyone with the link can sign the document without registration':
    'Скопіюйте це посилання та поділіться з отримувачами. Будь-хто, хто має посилання, може підписувати документ без реєстрації',
  'Access via link': 'Доступ за посиланням',
  Understood: 'Зрозуміло',
  'Users who have this link can': 'Користувачі, які мають це посилання можуть',
  template: 'шаблон',
  'Link is not valid anymore': 'Посилання вже недійсне',
  'It may have expired, or the document may have been deleted or modified by the owner':
    'Можливо, термін його дії закінчився, або документ був видалений чи змінений власником',
  'Create my document': 'Створити свій документ',
  'Go to documents': 'Перейти до документів',
  'Send and sign': 'Надсилайте та підписуйте',
  'Documents from any device using Diya, KEP (electronic digital signature) or SmartID':
    'Документи з будь-якого пристрою за допомогою Дія, КЕП(ЭЦП) або SmartID',
  'Secure and official': 'Безпечно та офіційно',
  'All signatures comply with legal requirements and have legal force':
    'Усі підписи відповідають вимогам законодавства та мають юридичну силу',
  'Fast and simple': 'Швидко та просто',
  'Forget about paper and mail. Sign documents in minutes':
    'Забудьте про папір і пошту. Підписуйте документи за лічені хвилини',
  'You doest not have an access for this document.': 'У вас немає доступу до даного документу',
  'Document has sent for view': 'Документ надіслано на перегляд',
  'Document has sent for fill': 'Документ надіслано на заповнення',
  'All participants will receive an email notification that they need to view the document. As soon as they complete the actions with the document, we will instantly notify you':
    'Всім учасникам прийде на пошту повідомлення про можливість переглянути документ. Як тільки вони виконають дії з документом, ми миттєво повідомимо вас',
  'All participants will receive an email notification that they need to fill the document. As soon as they complete the actions with the document, we will instantly notify you':
    'Всім учасникам прийде на пошту повідомлення про можливість заповнити документ. Як тільки вони виконають дії з документом, ми миттєво повідомимо вас',
  'Unauthorized user': 'Неавторизований користувач',
  'Not Found': 'Документ не знайдено',
  'Document successfully rejected': 'Документ успішно відхилено',
  'Templates search': 'Пошук шаблонів',
  'Template not found': 'Шаблон не знайдено',
  'In its original form without changes or signatures':
    'У початковому вигляді без змін та підписів',
  'With electronic signature in .p7s format': 'З електронним підписом у форматі .p7s',
  'Document with signing protocol': 'Документ з протоколом підписання',
  'Printable version': 'Версію для друку',
  'Downloaded documents': 'Завантажено документів',
  '{processed} of {total} done': '{processed} з {total} завантажено',
  'Download completed': 'Завантаження завершено',
  '{all} {total} {documents} are uploaded in "{format}" format':
    '{all} {total} {documents} завантажено в форматі "{format}"',
  'many documents': 'документів',
  'one document': 'документ',
  'few documents': 'документи',
  'Version for print': 'Версія для друку',
  'The overall process': 'Загальний процес',
  'Yes / No': 'Так / Ні',
  Settings: 'Налаштування',
  'External signature': 'Зовнішній підпис',
  'Internal signature': 'Внутрішній підпис',
  'Choose how you want to receive signed documents':
    'Оберіть, як ви хочете отримувати підписані документи',
  'When downloading, you will receive a ZIP archive containing the original document and separate electronic signature files':
    'При завантаженні ви отримаєте ZIP‑архів, що містить оригінал документа та окремі файли електронних підписів',
  'When you download, you will receive a single file that contains both the document and all signatures. This simplifies the transfer and verification of documents':
    'При завантаженні ви отримаєте один файл, який містить і документ, і всі підписи. Це спрощує передачу та перевірку документів',
  'Creates a unique QR code in the signing protocol':
    'Cтворює унікальний QR-код у протоколі підписання',
  'Add QR code to signing protocol': 'Додати QR-код до протоколу підписання',
  'Determine how long documents will be available via public link':
    'Визначте, як довго документи будуть доступні за публічним посиланням',
  'Choose a convenient corner of the document to place the stamp':
    'Оберіть зручний кут документа для розміщення печатки',
  'Location of the seal on the document': 'Розташування печатки на документі',
  'Public link access period': 'Термін доступу до публічних посилань',
  'QR code for quick access': 'QR‑код для швидкого доступу',
  'Electronic signature format': 'Формат електронного підпису',
  'Upper left corner': 'Верхній лівий кут',
  'Upper right corner': 'Верхній правий кут',
  'Lower left corner': 'Нижній лівий кут',
  'Lower right corner': 'Нижній правий кут',
  'Cancel document': 'Анулювати документ',
  'Canceling document': 'Анулювання документа',
  'All subscribers will receive cancellation notices and why all participants will need to sign up':
    'Усі підписанти отримають сповіщення про анулювання і для цього потрібен підпис усіх учасників',
  'Enter reason of document cancel': 'Вкажіть причину анулювання документа',
  Important: 'Важливо',
  'Sign and cancel': 'Підписати та анулювати',
  'The document is signed for cancellation': 'Документ підписано на анулювання',
  'All participants who have already signed the document will withdraw notification of its cancellation. As soon as you finish your actions with the document, you immediately receive notifications by mail':
    'Всі учасники, які вже підписали документ, отримають сповіщення про його анулювання. Як тільки вони виконають дії з документом, ви миттєво отримаєте повідомлення на пошту',
  'It’s impossible to squeeze this whole thing. If you need to make changes, it is better to create a new document':
    'Цю дію неможливо скасувати. Якщо вам потрібно внести зміни, краще створіть новий документ',
  'Reject cancellation': 'Відхилити анулювання',
  'Cancellation rejection': 'Відхилення анулювання',
  'The document will remain valid and all parties will be notified of your decision.':
    'Документ залишиться дійсним, і всі сторони будуть повідомлені про ваше рішення',
  'Enter reason of cancellation rejection': 'Вкажіть причину відхилення анулювання',
  'Cancellation rejected': 'Анулювання відхилено',
  'The sender will receive a notification that you have rejected the cancellation. The document remains valid and active.':
    'Відправнику прийде повідомлення про те, що ви відхилили анулювання. Документ залишається дійсним і активним',
  'Choose template': 'Обрати шаблон',
  'How do you plan to use the service?': 'Як ви плануєте використовувати сервіс?',
  'Choose the option that suits your work format':
    'Оберіть варіант, який підходить під ваш формат роботи',
  Personally: 'Особисто',
  'I work alone or as a sole proprietor and process documents myself':
    'Я працюю сам або як ФОП і самостійно обробляю документи',
  'Small team (2-10 people)': 'Невелика команда (2-10 осіб)',
  'Team works together on documents': 'Команда спільно працює з документами',
  'Large team (10+ people)': 'Велика команда (10+ осіб)',
  'Multiple departments or complex structure': 'Кілька відділів або складна структура',
  'How much paperwork do you have each month?': 'Який обсяг документів у вас щомісяця?',
  'We will select the optimal tariff for your volumes':
    'Підберемо оптимальний тариф під ваші обсяги',
  'Up to 10 documents': 'До 10 документів',
  'Individual documents for yourself or a small business':
    'Окремі документи для себе або малого бізнесу',
  '10-100 documents': '10-100 документів',
  'For small/medium businesses': 'Для малого / середнього бізнесу, що росте',
  'More than 100 documents': 'Більше 100 документів',
  'Rich document flow for large businesses': 'Насичений документообіг для великого бізнесу',
  'What would you like to do first?': 'Що б ви хотіли зробити спочатку?',
  'Start working with simple and convenient document management':
    'Почніть роботу з простого та зручного документообігу',
  'Create first document': 'Створити перший документ',
  'Upload a document and set up the approval process':
    'Завантажуйте документ і налаштуйте процес погодження',
  'Choose a template from the gallery': 'Обрати шаблон з галереї',
  'Ready-made document templates for business': 'Готові шаблони документів для бізнесу',
  'Invite colleagues to the system and set up permissions':
    'Запросіть колег у систему та налаштуйте права',
  'Choose the action you want to take': 'Оберіть дію, яку ви хочете зробити',
  '14 days without restrictions': '14 днів без обмежень',
  'We have activated a free 14-day access for you':
    'Ми активували для вас безкоштовний 14‑денний доступ',
  'to the Dubidoc Premium Tariff': ' до Premium тарифу Dubidoc',
  'Registration completed': 'Реєстрацію завершено',
  'Your profile has been created': 'Ваш профіль створено',
  'Full Premium Access': 'Повний Premium-доступ',
  Active: 'Активний',
  'All Premium functions for efficient document management':
    'Всі Premium-функції для ефективного документообігу',
  '100 outgoing documents per month': '100 вихідних документів на місяць',
  'Ready-made templates for a quick start': 'Готові шаблони для швидкого старту',
  'Structured folder system': 'Структурована система папок',
  'Document approval': 'Погодження документів',
  'Database of counterparties for fast work': 'База контрагентів для швидкої роботи',
  'Day 10: Reminder': 'День 10: Нагадування',
  'We will send you an email with information about the end of the period':
    'Ми надішлемо вам листа з інформацією про завершення періоду',
  'Day 14: End of Premium Access': 'День 14: Закінчення Premium‑доступу',
  'Switching to Free plan. You can continue': 'Перехід на Free тариф. Ви можете продовжити',
  'Team rate anytime': 'Premium тариф будь‑коли',
  'Start 14-day access': 'Вам доступний 14-денний Premium-доступ',
  'My dashboard': 'Мій дашборд',
  'You need to create an organization': 'Тепер вам потрібно створити організацію',
  'Add key': 'Додати ключ',
  'Add stamp': 'Додати печатку',
  'Enter password key': 'Вкажіть пароль ключа',
  'Enter password key (stamp)': 'Вкажіть пароль ключа (печатки)',
  'Change key': 'Змінити ключ',
  'Change stamp': 'Змінити печатку',
  'File key': 'Файловий ключ',
  'Valid until': 'Термін дії: до',
  'Saved keys': 'Збережені ключі',
  'available only in current browser': 'доступні тільки в поточному браузері',
  'Select another key': 'Обрати інший ключ',
  'Sign with EDS key (KEP)': 'Підписати ключем ЕЦП (КЕП)',
  'You have to select EDS key': 'Необхідно обрати ключ ЕЦП',
  Unactive: 'Неактивний',
  'Ends soon': 'Закінчується',
  'Do you really want to delete key {keyName}? This action cannot be undone':
    'Ви дійсно хочете видалити ключ {keyName}? Цю дію неможливо відмінити',
  'Remember key in this browser': 'Запамʼятовувати ключі в цьому браузері',
  'Select key for document signature': 'Оберіть ключ для підписання документа',
  'add stamp': 'Додайте печатку',
  'Check the read stamp information': 'Перевірте інформацію про зчитану печатку',
  'Autofill data': 'Автозаповнення даних',
  'Your personal data will be used only to fill in this document. Choose an authorization method':
    'Ваші персональні дані будуть використані лише для заповнення цього документа. Оберіть спосіб авторизації',
  'Authorize via Diia': 'Авторизація через Дія',
  'Verification data': 'Верифіковані дані',
  'Select which info receiver will fill with Diia or BankId':
    'Оберіть, яку інформацію отримувач заповнить через Дія або BankID',
  'Digital passport': 'Цифровий паспорт',
  'Automatically fills document fields with your data in 30 seconds':
    'Автоматично заповнить поля документа ваших даних за 30 секунд',
  'Fullname (surname, first name, last name)': 'ПІБ (прізвище, ім’я, по батькові)',
  'Birth day': 'Дата народження',
  'Bank assurance': 'Банківська точність',
  'Automatic document filling with verified data from your bank':
    'Автоматичне заповнення документа перевіреними даними з вашого банку',
  'Get data from bank': 'Отримати дані з банку',
  'Data obtained from Diia': 'Дані отримано з Дія',
  'Get accurate data without typos errors, get them from Diia or BankID':
    'Отримуйте точні перевірені дані без помилок введення через Дія або BankID',
  'Next time': 'Іншим разом',
  'Try autocomplete': 'Спробувати автозаповнення',
  'Go to document': 'Перейти до документа',
  'Among all of them, we chose you!': 'Серед усіх – ми обрали саме тебе!',
  'Get free access to advanced Dubidoc Premium features':
    'Отримайте безкоштовний доступ до розширених можливостей Dubidoc Premium',
  'Free during beta testing': 'Безкоштовно під час бета-тестування',
  'No cards. No obligations': 'Жодних карток. Жодних зобовʼязань',
  'Remind later': 'Нагадати пізніше',
  'Get access': 'Отримати доступ',
  'You activate autofill for the fields you need':
    'Ви активуєте автозаповнення для потрібних вам полів',
  'The recipient fills in the official data in just 30 seconds and without errors':
    'Отримувач заповнює офіційними даними всього за 30 секунд і без помилок',
  'Available only for text fields': 'Доступно тільки для текстових полів',
  'Folder has moved to folder {folderName}': 'Папку перенесено до папки "{folderName}"',
  Soon: 'Скоро',
  Payment: 'Оплата',
  'Tariff plans': 'Тарифні плани',
  Invoices: 'Рахунки',
  Tariffs: 'Тарифи',
  'Your tariff': 'Ваш тариф',
  'You have {count} free documents until end of the month':
    'У вас залишилось {count} безкоштовних документів до кінця місяця',
  Used: 'Використано',
  Left: 'Залишилось',
  'Overall limit': 'Загальний ліміт',
  'Price for tariff': 'Ціна за тариф',
  'Next payment': 'Наступний платіж',
  Unlimited: 'Необмежено',
  'Current balance': 'Поточний баланс',
  'Additional documents': 'Додаткові документи',
  'Need more documents? Buy more for lower price':
    'Потрібно більше документів? Купуйте окремо за вигідною ціною',
  Count: 'Кількість',
  'Price per document': 'Ціна за документ',
  'To be paid': 'До оплати',
  'Update to Premium': 'Оновити до Premium',
  'Go to payment': 'Перейти до оплати',
  'You are only using part of Dubidoc`s capabilities. Go Premium and work without restrictions':
    'Ви використовуєте лише частину можливостей Dubidoc. Перейдіть на Premium та працюйте без обмежень',
  'Maximum productivity and advanced electronic document management capabilities':
    'Максимальна продуктивність та розширені можливості електронного документообігу',
  'Available until': 'Дійсний до',
  'Documents payment': 'Оплата документів',
  'Instantly top up your document limit and don`t waste time waiting':
    'Миттєво поповніть ліміт документів та не втрачайте час на очікування',
  'Plan payment': 'Оплата за тариф',
  'Choose a convenient payment method and save all your progress and settings in your workflow':
    'Оберіть зручний спосіб оплати та збережіть весь свій прогрес і налаштування в документообігу',
  'Premium plan for {months} mon': 'Premium тариф на {months} міс',
  'Invoice for payment': 'Рахунок на оплату',
  'Pay from balance': 'Сплатити з балансу',
  'Continue plan': 'Продовжити тариф',
  'Card payment': 'Оплата карткою',
  'Selected plan': 'Обраний тариф',
  '₴/month': '₴/міс',
  'Go to free': 'Перейти на безкоштовний',
  'Try for free': 'Спробувати безкоштовно',
  Individually: 'Індивідуально',
  'For teams 10+ users': 'Для команд 10+ користувачів',
  'Plan demo': 'Запланувати демо',
  'Individual settings for your business': 'Розробка додаткового функціоналу під ваш бізнес',
  'Full options from "Premium"': 'Повний пакет тарифу “Premium”',
  'Free forever': 'Безкоштовно завжди',
  'Do not need card for activation': 'Не потрібна картка для активації',
  'Discuss price': 'Зверніться для ціноутворення',
  'Subscription active until': 'Підписка активна до {date}',
  'Paid until': 'Оплачено до',
  'The date until which the Dubidoc Premium plan is paid. Limits will reset at the start of the next period':
    'Дата до якої оплачено тариф Dubidoc Premium, ліміти оновляться з початком наступного періоду',
  'Comparing plans table': 'Порівняльна таблиця тарифів',
  'Documents and limits': 'Документи та ліміти',
  'Incoming documents/month': 'Вихідні документи/місяць',
  'Receiving documents': 'Отримання документів',
  'Users in organization': 'Користувачі в організації',
  'Rights access users': 'Права доступу користувачам',
  'Signature via link': 'Підпис через посилання',
  'By EDS key (KEP)': 'Ключем ЕЦП (КЕП)',
  'Organization with documents': 'Організація з документами',
  'Folder system': 'Структурування за папками',
  'Counterparts database': 'База контрагентів',
  Commenting: 'Коментування',
  'Participants route': 'Маршрути',
  Canceling: 'Анулювання',
  Integrations: 'Інтеграції',
  'Document widget': 'Віджет документа',
  'Custom integration': 'Кастомна інтеграція',
  Security: 'Безпека',
  Encryption: 'Шифрування',
  Saving: 'Зберігання',
  'Need help': 'Потрібна допомога',
  'Need help with plan selection?': 'Потрібна допомога з вибором тарифу?',
  'We will call you in 5 minutes and help select optimal variant':
    'Зателефонуємо за 5 хвилин і допоможемо обрати оптимальний варіант',
  'For each plan you can purchase additional outgoing documents for':
    'Для кожного тарифу є можливість придбати додаткові вихідні документи за',
  '2.40 UAH/piece': '2.40 грн/шт',
  'We will setup document management for your needs': 'Налаштуємо документообіг під ваші потреби',
  'Join leading companies that have already transformed their business processes':
    'Приєднуйтесь до провідних компаній, які вже трансформували свої бізнес-процеси',
  'Your name': 'Ваше імʼя',
  'Phone number': 'Номер телефону',
  'Company size': 'Розмір компанії',
  'Request sent!': 'Заявка надіслана!',
  'We will contact you shortly to set up a personalized plan':
    'Ми зв’яжемося з вами найближчим часом для налаштування індивідуального тарифу',
  'Payment date': 'Дата оплати',
  'Payment code': 'Платіжний код',
  'Start your financial story': 'Почніть свою фінансову історію',
  'Your invoices will appear here after your first purchase. Start with Premium or additional documents':
    "Ваші рахунки з'являться тут після першої покупки. Почніть з Premium тарифу або додаткових документів",
  'Buy documents': 'Купити документи',
  Payed: 'Оплачено',
  Awaits: 'Очікується',
  Cancelled: 'Скасовано',
  'Pay by card': 'Оплатити карткою',
  'Your documents active': 'Ваші документи активні',
  'Your bonus documents': 'Ваші бонусні документи',
  'Track usage and plan for future with maximal efficiency':
    'Відслідковуйте використання та плануйте наперед для максимальної ефективності',
  'Documents limit': 'Ліміт документів',
  Bought: 'Куплено',
  'Buy more documents': 'Купити ще документи',
  'Payment in process': 'Платіж обробляється',
  'Keep working! The system automatically activates the services after the funds are credited. You can track the status in the “Accounts” section':
    'Продовжуйте працювати! Система автоматично активує послуги після зарахування коштів. Статус можна відстежити в розділі “Рахунки”',
  'Continue to work': 'Продовжити роботу',
  'View invoices': 'Переглянути рахунки',
  'Payment has charged successfully': 'Оплата пройшла успішно',
  'Payment was not charged': 'При оплаті відбулася помилка',
  Acts: 'Акти',
  'Build reporting from day one': 'Будуйте звітність з першого дня',
  'Receive official certificates of work performed automatically after each paid service for reporting purposes':
    'Отримуйте офіційні акти виконаних робіт автоматично після кожної оплаченої послуги для ведення звітності',
  'Period (from - to)': 'Період (з - по)',
  'Control your expenses': 'Контроль ваших витрат',
  'Transparency of each transaction — no hidden fees, only the result':
    'Прозорість кожної транзакції — ніяких прихованих платежів, тільки результат',
  'Control your financial statements': 'Контролюйте свою фінансову звітність',
  'All certificates of work performed in one place - download, save, transfer to accounting':
    'Всі акти виконаних робіт в одному місці — завантажуйте, зберігайте, передавайте в бухгалтерію',
  'Increase limit': 'Збільшити ліміт',
  'Used count of documents': 'Використано {used} з {limit} документів',
  'Active premium': 'Активувати Premium',
  leftDays_one: 'Залишився {count} день',
  leftDays_few: 'Залишилося {count} дні',
  leftDays_many: 'Залишилося {count} днів',
  'Manage subscription': 'Керування підпискою',
  'Welcome to the club': 'Вітаємо в клубі 👋🏼',
  'Your business now has access to all premium document management features':
    'Ваш бізнес тепер має доступ до всіх преміум‑функцій документообігу',
  'Prepare for efficient document management': 'Підготуйтеся до ефективного документообігу',
  '+20 documents to your plan': ' +20 документів до свого плану',
  'Congratulations! All tasks completed': 'Вітаємо! Всі завдання виконані',
  'Keep an eye out for new tasks that will appear in your account':
    'Стежте за новими завданнями, які з`являтимуться у вашому кабінеті',
  'Send 10 documents for signature': 'Відправити 10 документів на підпис',
  'See how easy it is to get a signature in Dubidoc':
    'Переконайтесь, наскільки легко отримати підпис у Dubidoc',
  'Send 10 documents for approval': 'Відправити 10 документів на погодження',
  'Start the process of document approval within the company':
    'Запустіть процес погодження документів всередині компанії',
  'Send 10 documents based on a template': 'Відправити 10 документів на основі шаблону',
  'Use templates for quick submissions': 'Використовуйте шаблони для швидкої відправки',
  'Add 1 contact': 'Додайте 1 контакт',
  'Create a database of counterparties for quick document sending':
    'Створіть базу контрагентів для швидкої відправки документів',
  'Invite 1 colleague': 'Запросити 1 колегу',
  'Add collaborators to collaborate on documents':
    'Додайте співробітників для спільної роботи з документами',
  'Create 1 document template': 'Створити 1 шаблон документа',
  'The templates have interactive fields to fill in. Try it out!':
    'Шаблони мають інтерактивні поля для заповнення. Спробуйте!',
  'Install the application': 'Встановити застосунок',
  'Sign and send documents directly from your smartphone':
    'Підписуйте і надсилайте документи прямо зі смартфона',
  'Balance has charged successfully': 'Кошти з балансу успішно списані',
  'Speed up your document management with Contacts section':
    'Прискорте ваш документообіг з розділом Контакти',
  'To automatically fill in recipient details when creating documents':
    'Для автоматичного заповнення даних отримувача під час створення документів',
  'Available with': 'Доступно з',
  'Premium plan': 'Premium-тарифом',
  'You documents limit updates every month for plan documents amount':
    'Ваш ліміт оновлюється до {amount} документів щомісяця згідно з тарифом',
  'You have a full year for using your documents':
    'У вас є цілий рік для використання купленних документів',
  'Pay from balance ': 'Оплатити з балансу',
  'First 14 days for free!': 'Перші 14 днів безкоштовно!',
  'Premium access to assets': 'Premium-доступ активований',
  'Organization created - all Dubidoc features for 14 days without restrictions':
    'Організацію створено - всі можливості Dubidoc на 14 днів без обмежень',
  'Unleash the full power of the Premium version': 'Розкрийте всю потужність Premium версії',
  'Unleash the full power of the Team Edition and get': 'Розкрийте потенціал документообігу',
  Free: 'Безоплатний',
  'Unleash the full potential of electronic document management with the “Premium” tariff':
    'Розкрийте весь потенціал електронного документообігу з тарифом “Premium”',
  'Try 14 days free': 'Спробувати 14 днів безкоштовно',
  'To activate access, please add your organization': 'Щоб активувати доступ — додайте організацію',
  'Activate premium plan to use contacts':
    'Для використання функціоналу контактів активуйте Premium',
  'Documents have been successfully created': 'Документи успішно створено',
  File: 'Файл',
  'A personal offer for your business': 'Персональна пропозиція для вашого бізнесу',
  'Configure route actions': 'Налаштовуйте дії в маршруті',
  'Ask who should review, approve, or sign a document - in the right order':
    'Задавайте, хто має переглянути, погодити чи підписати документ - в потрібному порядку',
  'Run routes for any processes': 'Запускайте маршрути для будь-яких процесів',
  'Suitable for vacation requests, orders, approvals with the manager, accounting, lawyer, etc':
    'Підходить для заяв на відпустку, наказів, погоджень із керівником, бухгалтерією, юристом тощо',
  'One document - multiple signatories': 'Один документ - декілька підписантів',
  'The document goes through all stages of approval automatically, without manual forwarding':
    'Документ проходить всі етапи узгодження автоматично, без ручного пересилання',
  'Transparency at every stage': 'Прозорість на кожному етапі',
  'Track who has already approved a document and who hasn`t - all in one window':
    'Відстежуйте, хто вже погодив документ, а хто ще ні - все в одному вікні',
  'Automatic statuses and reminders': 'Автоматичні статуси й нагадування',
  'Each participant sees only their own step. Reminders come automatically, without your intervention':
    'Кожен учасник бачить лише свій крок. Нагадування приходять автоматично, без вашого втручання',
  'Ability to react route': 'Можливість відреагувати маршрут',
  'If necessary, add/change route participants or their target action':
    'При необхідності додавайте/змінюйте учасників маршрута або їх цільову дію',
  'Comment documents': 'Коментуйте документи',
  'All discussions stay next to the document - never get lost in the correspondence':
    'Усі обговорення залишаються поруч із документом - ніколи не загубляться в листуванні',
  'Comments from all participants': 'Коментарі від усіх учасників',
  'Employees, managers, accountants can leave their questions and clarifications in a convenient format':
    'Працівники, менеджери, бухгалтери можуть залишати свої запитання та уточнення в зручному форматі',
  'Fewer unnecessary meetings and letters': 'Менше зайвих зустрічей і листів',
  'Resolve everything on the document at once, without having to write separate letters or make calls':
    'Вирішуйте все по документу одразу, без потреби писати окремі листи чи проводити дзвінки',
  Folders: 'Папки',
  'Folders, like in a physical archive': 'Папки, як у фізичному архіві',
  'Create your own structure of convenient folders - by employees, document types or periods':
    'Створюйте власну структуру зручних папок - за працівниками, типами документів або періодами',
  'Fast search': 'Швидкий пошук',
  'Find the document you need in seconds thanks to filters, tags and search':
    'Знаходьте потрібний документ за кілька секунд завдяки фільтрам, тегам та пошуку',
  'Organized storage': 'Впорядковане зберігання',
  'After signing, documents are stored in the archive - you always know where to find them':
    'Після підписання документи зберігаються в архіві - ви завжди знаєте, де їх знайти',
  'Create own base of contacts': 'Створюйте власну базу контактів',
  'Save the full name, email and EDRPOU of counterparties so that you don`t have to re-enter them every time':
    'Зберігайте ПІБ, email і ЄДРПОУ контрагентів, щоб не вводити їх щоразу заново',
  'Send documents in few clicks': 'Надсилайте документи в кілька ліків',
  'When creating a document, the contact will be pulled up automatically - without searching in other systems':
    'Під час створення документа контакт підтягнеться автоматично - без пошуку в інших системах',
  'Remember instead you': 'Памʼятає замість вас',
  'All the people you know are already in the system - just select and send':
    'Всі знайомі вам люди вже в системі - просто оберіть і надсилайте',
  'You have 14 days of Premium access': 'Вам доступний 14-денний Premium-доступ',
  'Folders, routes, comments, collaboration - everything to work with documents faster and more conveniently. Now available in Premium':
    'Папки, маршрути, коментарі, спільна робота - усе, щоб працювати з документами швидше і зручніше. Тепер це доступно в Premium',
  '14 days free. Just click and go': '14 днів безкоштовно. Просто натисніть і вперед',
  'You can test all Premium features right now - without restrictions':
    'Ви можете протестувати всі можливості Premium вже зараз - без обмежень',
  'Do not sign': 'Не підписувати',
  'Sender (You)': 'Відправник (Ви)',
  'Generate public link': 'Згенерувати публічне посилання',
  'Value copied': 'Значення скопійовано',
  'Confirmation of current email': 'Підтвердження поточної пошти',
  'We sent confirmation code to email': 'Ми надіслали код підтвердження на адресу',
  'Enter new email address': 'Введіть нову електронну адресу',
  'New email address': 'Нова електронна адреса',
  'Confirmation of new email': 'Підтвердження нової пошти',
  'All your documents, templates, and settings will remain unchanged. Only the login address will change':
    'Всі ваші документи, шаблони та налаштування залишаться без змін. Змінюється лише адреса для входу в систему',
  'On approve': 'На погодження',
  'On sign': 'На підпис',
  'On view': 'На перегляд',
  'On fill': 'На заповнення',
  'Activate access': 'Активувати доступ',
  'Date of enrollment': 'Дата зарахування',
  'ID of transaction': 'ID транзакції',
  Acquirer: 'Еквайер',
  'Payment description': 'Призначення платежу',
  Parsed: 'Рознесений',
  'Date of arrival': 'Дата надходження',
  Balances: 'Баланси',
  Payments: 'Платежі',
  'Invoice number': 'Номер рахунку',
  'ID of act': 'ID акту',
  'Tax bills': 'Податкові накладні',
  'Payment number': 'Номер платежу',
  'Error text': 'Текст помилки',
  'Payment sum, ₴': 'Сума платежу, ₴',
  'Tax bill number': 'Номер податкової накладної',
  'Act number': 'Номер акту',
  'Date of sending': 'Дата надсилання',
  New: 'Новий',
  new: 'Нове',
  'Discount sum, ₴': 'Сума зі знижкою, ₴',
  'Total sum, ₴': 'Загальна сума, ₴',
  Paid: 'Оплачений',
  Created: 'Створений',
  'Date of payment': 'Дата оплати',
  'Date of invoice': 'Дата виставлення',
  'Sum, ₴': 'Сума, ₴',
  'Document state': 'Стан документу',
  'Name/EDRPOU/Email': 'Назва/ЄДПРОУ/Email',
  'Name/EDRPOU': 'Назва/ЄДПРОУ',
  Sent: 'Надісланий',
  'Document detail': 'Деталі документу',
  'General info': 'Загальна інформація',
  'Date of creation': 'Дата створення',
  'Signature type': 'Тип підпису',
  internal: 'Внутрішній',
  external: 'Зовнішній',
  'Archived document': 'Архівований документ',
  'Templated document': 'Документ на основі шаблону',
  'Cancellation act': 'Акт анулювання',
  'Public document': 'Загальнодоступний документ',
  'File ext': 'Файлове розширення',
  'Refused document': 'Відхилений документ',
  'Participants ': 'Учасники',
  'Organization name': 'Назва організації',
  'Start balance': 'Баланс на початок періоду',
  'End balance': 'Баланс на кінець періоду',
  'Amount of payments': 'Сума платежі за період',
  'Amount of acts': 'Сума актів за період',
  'Go to admin': 'Перейти в адмінку',
  'Come back to account': 'Назад до акаунту',
  'Registration date': 'Дата реєстрації',
  'User detail': 'Деталі користувача',
  Sessions: 'Сесії',
  Device: 'Пристрій',
  'Last access': 'Останній вхід',
  'Show tag in documents': 'Показувати тег на документах',
  'Date of deletion': 'Дата видалення',
  'Date of singing': 'Дата підписання',
  Position: 'Посада',
  Stamp: 'Печатка',
  User: 'Користувач',
  Action: 'Дія',
  document_viewed: 'Прочитано',
  document_signed: 'Підписано',
  document_rejected: 'Відхилено',
  document_approved: 'Погоджено',
  'Organization detail': 'Деталі організації',
  'Public link available (days)': 'К-сть днів валідного публічного посилання',
  'Tariff name': 'Назва тарифу',
  'Balance, ₴': 'Баланс, ₴',
  'Payer code': 'Код платника',
  Billing: 'Білінг',
  Periods: 'Періоди',
  'Used documents': 'К-сть використаних документів',
  'Available documents': 'К-сть доступних документів',
  'Template detail': 'Деталі шаблону',
  'Trial access': 'Випробувальний період',
  'For Dubidoc Premium activation you need to add organization':
    'Для активації Dubidoc Premium необхідно додати організацію',
  'Control document approvals': 'Контролюйте <br /> погодження документів',
  'Set routes for document approval: who should review, approve or sign. Track the status of each stage and get results in one place':
    'Задавайте маршрути для узгодження документів: хто має переглянути, погодити чи підписати. Відстежуйте статус кожного етапу та отримуйте результат в одному місці',
  'Set up digital cabinet': 'Налаштовуйте <br /> цифрову шафу',
  'Organize documents in convenient folders and quickly find what you need thanks to filters, sorting and search':
    'Організуйте документи у зручні папки та швидко знаходьте потрібне завдяки фільтрам, сортуванню та пошуку',
  'Comment on documents using chat': 'Коментуйте документи за допомогою чата',
  'All discussions and agreements remain with the document forever':
    'Всі обговорення та домовленості залишаються з документом назавжди',
  'Save important contacts': 'Зберігайте важливі контакти',
  'Add people to your database to quickly find them and send documents in a few clicks':
    'Додавайте людей до своєї бази, щоб швидко знаходити їх і надсилати документи в кілька кліків',
  Employees: 'Співробітники',
  Widget: 'Віджет',
  'Add signature to your website': 'Додайте підпис <br /> на ваш сайт',
  'Add your entire team and set roles — Employee, Administrator, Chief Accountant. Work together in a single space with no limits on the number of users':
    'Додавайте всю команду та налаштовуйте ролі — Співробітник, Адміністратор, Головний бухгалтер. Працюйте разом у єдиному просторі без обмежень на кількість користувачів',
  'Add the whole team and set up roles — Employee, Chief Accountant. Work together in a single space without restrictions on the number of users':
    'Додавайте всю команду та налаштовуйте ролі — Співробітник, Головний бухгалтер. Працюйте разом у єдиному просторі без обмежень на кількість користувачів',
  API: 'API',
  'Set up API integration': 'Налаштуйте інтеграцію через API',
  'Connect Dubidoc with your CRM, ERP or other systems. Automate document exchange and embed signature into your own business processes':
    'Зʼєднайте Dubidoc із вашими CRM, ERP або іншими системами. Автоматизуйте обмін документами та вбудуйте підпис у власні бізнес-процеси',
  'Increase the limit right now': 'Збільшіть ліміт вже зараз',
  'Switch to 100 outgoing documents per month and set up all your document flow in Dubidoc, without unnecessary transitions between systems and annual subscriptions':
    'Перейдіть на 100 вихідних документів на місяць і налаштуйте весь свій документообмін в Dubidoc, без зайвих переходів між системами і річних передплат',
  'Organization Data': 'Дані організації',
  'Organization billing information': 'Білінгова інформація організації',
  'Synchronize data': 'Синхронізувати дані',
  'Edit manually': 'Редагувати вручну',
  'This information will be used for invoicing and financial reporting':
    'Ця інформація буде використовуватись для виставлення рахунків та фінансової звітності',
  'Full name of the responsible person': 'ПІБ відповідальної особи',
  'Official position': 'Офіційна посада',
  'Registered address of the organization': 'Юридична адреса організації',
  'Corporate email address': 'Корпоративна електронна адреса',
  'Contact phone number': "Контактний номер для зв'язку",
  'VAT payer': 'Платник ПДВ',
  'not specified': 'не вказано',
  Discard: 'Скасувати',
  'Needs update': 'Потребує оновлення',
  Updated: 'Оновлено',
  'Data has been successfully saved': 'Дані успішно збережено',
  'Request to synchronize data has successfully sent':
    'Заявка на синхронізацію даних успішно подана',
  'After handling request, you have to refresh the page':
    'Після оброблення заявки на оновлення даних, необхідно оновити сторінку',
  Description: 'Опис',
  'Process payment again': 'Опрацювати платіж знову',
  'Edit payment': 'Редагувати платіж',
  'Payment has edited': 'Платіж відредаговано',
  'Tax bill detail': 'Деталі податкової накладної',
  'Document id': 'ID документу',
  DRFO: 'ДРФО',
  'Activate premium': 'Активувати преміум',
  'Add sorry bonus': 'Додати сорі бонус',
  'Select months count': 'Оберіть кількість місяців',
  'Now organization has access for premium': 'Premium надано даній організації',
  'Max users in organization': 'Максимальна к-сть користувачів у організації',
  'Max documents': 'Максимальна к-сть документів',
  'Select tariff': 'Оберіть тариф',
  'Documents count': 'К-сть документів',
  'Receiver name': 'Ім`я отримувача',
  'Date of compilation': 'Дата складання',
  'Number of Tax Bill': 'Номер ПН',
  'Name of buyer': 'Найменування покупця',
  "Registration number of the taxpayer's registration card or series (if available) and passport number":
    'Реєстраційний номер облікової картки платника податків або серія (за наявності) та номер паспорта',
  "Registration number of the taxpayer's registration card":
    'Реєстраційний номер облікової картки платника податків',
  'Date of registration tax bill in tax': 'Дата реєстрації ПН в податковій',
  'buyer IPN': 'ІПН покупця',
  'Sum of tax bill': 'Сума ПН',
  'Sum of PDV': 'Сума ПДВ',
  'Nomenclature of Tax Bill': 'Опис (номенклатура) товарів / послуг продавця',
  'Signature required': 'Повинен підписати',
  Revoke: 'Скасувати сесію',
  'Tax bill has successfully edited': 'Податкова накладна успішно відредагована',
  'Download report': 'Завантажити звіт',
  'Quantity (volume, amount)': 'Кількість (обʼєм, обсяг)',
  'Unit supply price': 'Ціна постачання одиниці товару',
  'Delivery volumes excluding VAT': 'Обсяги постачання без ПДВ',
  'VAT sum': 'Сума ПДВ',
  'Read the key through {provider}': 'Зчитати ключ через {provider}',
  'Signature via {provider}': 'Підпис через {provider}',
  Error: 'Помилка',
  Completed: 'Виконаний',
  'Ready to ship': 'Готовий до відправки',
  'Tax bill sum': 'Сума ПН',
  'Sum without VAT': 'Сума без ПДВ',
  'Tax bill date': 'Дата ПН',
  VAT: 'ПДВ',
  "Receiver's name": "Ім'я отримувача",
  Registered: 'Зареєстровано',
  'EDS keys': 'Ключі ЕЦП',
  'Select provider for creating new EDS key':
    'Оберіть провайдера для створення електронного цифрового підпису',
  MonoKEP: 'MonoKEП',
  'Qualified electronic signatures from Monobank. Fast registration through the mobile application':
    'Кваліфіковані електронні підписи від Monobank. Швидке оформлення через мобільний застосунок',
  'Get KEP': 'Отримати КЕП',
  'Generate QR-code': 'Згенерувати QR-код',
  'Update QR-code': 'Оновити QR-код',
  'Creating monoKEP': 'Створення monoКЕП',
  'Select key type. Detailed instructions can be viewed on the official':
    'Оберіть тип ключа. Детальну інструкцію можна переглянути на офіційному',
  website: 'сайті',
  FOP: 'ФОП',
  'Juridical person': 'Юридична особа',
  'For physical person-entrepreneurs': 'Для фізичних осіб-підприємців',
  'For legal entities and organizations': 'Для юридичних осіб та організацій',
  'For FOP': 'Для ФОП',
  'For business': 'Для бізнесу',
  'Scan QR-code': 'Відскануйте QR-код',
  'Scan this QR code with the camera of your phone and follow the instructions in the Monobank application to complete the creation of the key':
    'Відскануйте цей QR-код камерою телефона та дотримуйтесь інструкцій в застосунку Monobank для завершення створення ключа',
  "Electronic signatures from Ukraine's leading CSP. Support for all types of document flow":
    'Електронні підписи від провідного українського ЦСК. Підтримка всіх типів документообороту',
  'Notify by email': 'Повідомити на пошту',
  'You are among the first!': 'Ви серед перших!',
  'We will notify you as soon as the service is available':
    'Ми повідомимо вас, як тільки сервіс стане доступним',
  'AI Assistant': 'AI помічник',
  'It is not possible to use AI when there are already fields in the template':
    'Неможливо використовувати AI коли вже є поля в шаблоні',
  'Create templates with AI': 'Створюйте шаблони з AI',
  'Forget about routine work - let artificial intelligence do it for you':
    'Забудьте про рутинну роботу — нехай штучний інтелект зробить це за вас',
  Later: 'Пізніше',
  'Create template with AI': 'Створення шаблону з AI',
  'We are just training AI to recognize fields, so the result may be inaccurate. But it already works well with documents that have underlining like ________.':
    'Ми тільки навчаємо AI розпізнавати поля, тож результат може бути неточним. Але вже зараз він добре працює з документами, де є підкреслення типу _________.',
  'AI understands the context and determines the field types':
    'AI розуміє контекст і визначає типи полів',
  'Try AI now': 'Спробувати AI зараз',
  'Hint: It works best with documents that have underlining ___________ indicating the fields to fill in':
    'Підказка: Найкраще працює з документами, де є підкреслення ___________, які вказують на місця для заповнення',
  'AI has successfully created a template with dynamic fields!':
    'AI успішно створив шаблон з динамічними полями!',
  'Cancel action': 'Скасувати дію',
  'AI changes have been undone': 'Зміни AI скасовано',
  'AI generation completed successfully': 'AI генерація завершена успішно',
  'Template creation with AI': 'Створення шаблону за допомогою AI',
  'Analyzing document structure...': 'Аналізуємо структуру документа...',
  'Identifying fields to fill...': 'Визначаємо поля для заповнення...',
  'Creating dynamic fields...': 'Створюємо динамічні поля...',
  'Finalizing generation...': 'Завершуємо генерацію...',
  'How do you like the AI assistant?': 'Як вам AI-помічник?',
  'Your feedback helps us improve the automatic field creation':
    'Ваш відгук допоможе нам покращити автоматичне створення полів',
  Terrible: 'Жахливо',
  Bad: 'Погано',
  Normal: 'Нормально',
  Good: 'Добре',
  Excellent: 'Ідеально',
  'Send feedback': 'Надіслати відгук',
  'What can be improved?': 'Що можна покращити?',
  'What needs improvement?': 'Що потребує покращення?',
  'Tell us more about AI performance': 'Розкажіть детальніше про роботу AI',
  'Field names': 'Назви полів',
  'Field types': 'Типи полів',
  'Field placement': 'Розташування полів',
  'Speed of work': 'Швидкість роботи',
  'Missed some fields': 'Пропустив деякі поля',
  'Wrong types': 'Неправильні типи',
  Placement: 'Розташування',
  'Missed fields': 'Пропустив поля',
  'Created extra fields': 'Створив зайві поля',
  'Inaccurate field names': 'Неточні назви полів',
  'Feedback sent successfully': 'Відгук успішно надіслано',
  'Failed to send feedback': 'Помилка надсилання відгуку',
  'User identifier': 'Ідентифікатор користувача',
  'Please apply at least one filter to load documents':
    'Будь ласка, застосуйте хоча б один фільтр для завантаження документів',
  'Documents has been signed with stamp successfully': 'На документи успішно накладено печатку!',
  'Applying stamp': 'Накладається печатка',
  'EDS key signed': 'Підписано ЕЦП',
  'Stamp key applied': 'Накладено печатку',
  'EDS key error': 'Помилка ЕЦП ключа',
  'Stamp key error': 'Помилка печатки',
  'Email changed': 'Email змінено',
  'Now you can use new email for getting mails':
    'Тепер ви можете користуватися новою адресою для отримання повідомлень',
  'Read the key through Mono.Signature': 'Зчитати ключ через monoКЕП',
  'Sign organization edrpou': 'Підписати ЄДРПОУ організації',
  'Change order': 'Змінити порядок',
  'Generating link...': 'Генерується посилання...',
  Connect: 'Підключити',
  'Connect integration': 'Підключити інтеграцію',
  'Select EDO which you want to connect': 'Оберіть сервіс ЄДО, який ви хочете підключити',
  'Enter token Vchasno': 'Вставте токен з системи Вчасно',
  Token: 'Токен',
  'Integration has been successfully connected': 'Інтеграцію успішно підключено',
  'Not active': 'Не активний',
  Vchasno: 'Вчасно',
  'Edo service': 'Сервіс ЕДО',
  'Enter recipient`s edrpou': 'Вкажіть ЄДРПОУ отримувача',
  'Required field': 'Обовʼязкове поле',
  'Fill in all the required fields': 'Заповніть обовʼязкові поля',
  'Optional field': 'Опційне поле',
  Signatures: 'Підписи',
  'Activate tariff': 'Активувати тариф',
  'Sent on sign': 'Надіслано на підпис',
  'Sent on approve': 'Надіслано на погодження',
  'Sent on view': 'Надіслано на перегляд',
  'Sent on filling': 'Надіслано на заповнення',
  Filled: 'Заповнено',
  'Click to make field optional': 'Клікніть, щоб зробити поле не обовʼязковим',
  'Click to make field required': "Клікніть, щоб зробити поле обов'язковим",
  'EDO services': 'Сервіси ЕДО',
  'Connect external systems for document exchange with counterparties':
    'Підключіть зовнішні системи для обміну документами з контрагентами',
  'Vchasno.EDO': 'Вчасно.ЕДО',
  'Electronic document management system for exchanging documents with counterparties via the Vchasno system':
    'Система електронного документообігу для обміну документами з контрагентами через систему Вчасно',
  'Connecting Vchasno': 'Підключення Вчасно',
  'Where to find integration token?': 'Де знайти токен інтеграції?',
  'Go to your personal account on Vchasno and copy the access token':
    'Перейдіть в особистий кабінет Вчасно та скопіюйте токен доступу',
  'Detailed instruction ↗︎': 'Детальна інструкція ↗︎',
  Disconnect: 'Відключити',
  'Your request to organization has been successfully reject':
    'Запрошення до організації успішно відхилено',
  'Send now': 'Надіслати зараз',
  'Send tomorrow at 09:00': 'Надіслати завтра о 09:00',
  'Plan send': 'Запланувати відправку',
  at: 'о',
  'Click to send now': 'Натисніть, щоб надіслати зараз',
  'Click to send later': 'Натисніть, щоб надіслати пізніше',
  'Your document will be send at {date}': 'Ваш документ буде надіслано {date}',
  'Planned send': 'Заплановане відправлення',
  'Change send date': 'Змінити час відправки',
  'Cancel send': 'Скасувати відправку',
  'The document will not be sent automatically. You can send it manually later':
    'Документ не буде відправлено автоматично. Ви зможете відправити його вручну пізніше',
  'Yes, cancel': 'Так, скасувати',
  'Shipment cancelled. Can be sent manually': 'Відправку скасовано. Можна відправити вручну',
  'Document will be send automatically at datetime':
    'Документ буде відправлено автоматично {date} о {time}',
  Datetime: '{date} о {time}',
  'Automatic archiving': 'Автоматична архівація',
  'Documents will be automatically moved to the archive according to your rules':
    'Документи будуть автоматично переміщатися в архів за вашими правилами',
  'Enable automatic archiving': 'Увімкнути автоматичну архівацію',
  'Select an archiving rule': 'Оберіть правило архівації',
  'After all sign': 'Після завершення підписання',
  'A while after signing': 'Через певний час після підписання',
  'The document will automatically be moved to the archive immediately after all actions in the route have been completed(approval, signing, etc.). Ideal for processes with a clear end point':
    'Документ автоматично переміститься в архів одразу після того, як він буде підписаний усіма сторонами. Ідеально для процесів, де підписання є фінальною дією',
  'Automatically archive all signed documents after a selected period of time. Convenient for keeping long-term projects organised':
    'Архівувати всі підписані документи автоматично через обраний період часу. Зручно для підтримки порядку в довгострокових проєктах',
  'In {days} days': 'Через {days} днів',
  Instantly: 'Миттєво',
  'Documents are archived {days} days after signing':
    'Документи архівуються через {days} днів після підписання',
  'Documents are instantly archived after all actions are completed':
    'Документи миттєво архівуються після завершення всіх дій',
  'Auto archivation disabled': 'Автоматична архівація документів вимкнена',
  'HR platform for automatic exchange of HR documents and contracts with employees':
    'HR-платформа для автоматичного обміну кадровими документами та договорами з працівниками',
  'Go to PeopleForce → Settings → Security → API keys (at the bottom of the page) → click Generate':
    'Увійдіть в PeopleForce → Налаштування → Безпека → API ключі (внизу сторінки) → натисніть Згенерувати',
  'Connect PeopleForce': 'Підключення PeopleForce',
  'Only users with the Administrator role can create API keys':
    'Тільки користувачі з роллю Адміністратора можуть створювати API ключі',
  'Enter token PeopleForce': 'Вставте токен з системи PeopleForce',
  'Select employee': 'Оберіть співробіника',
  'Select folders': 'Оберіть папки',
  'Automate document sending': 'Автоматизуйте відправку документів',
  'Create your first route to quickly send documents to regular recipients':
    'Створіть свій перший маршрут для швидкої відправки документів постійним отримувачам',
  'Create route': 'Створити маршрут',
  'New route': 'Новий маршрут',
  'Create route for quick document sending': 'Створіть маршрут для швидкої відправки документів',
  'Example: Approving documents': 'Наприклад: Погоження документів',
  'Route name': 'Назва маршруту',
  'Add recipient': 'Додати отримувача',
  'Save route': 'Зберегти маршрут',
  Recipients: 'Отримувачі',
  'At least one participant should approve': 'Хоча б один має погодити',
  'Route has been created': 'Маршрут створено',
  'Used {count} times':
    'Використано {count} раз | Використано {count} рази | Використано {count} разів',
  'Created at {date}': 'Створено {date}',
  '{count} members': '{count} отримувач | {count} отримувача | {count} отримувачів',
  'One approve is enough': 'Достатньо одного погодження',
  'View details': 'Переглянути деталі',
  'Route deleting': 'Видалення маршруту',
  'Delete route': 'Видалити маршрут',
  'The route will be deleted permanently. This action cannot be undone':
    'Маршрут буде видалено назавжди. Цю дію не можна буде скасувати',
  'Route has been successfully deleted': 'Маршрут успішно видалено',
  'Edit route': 'Редагувати маршрут',
  'Route has been updated': 'Маршрут успішно відредаговано',
  Saved: 'Збережений',
  Public: 'Публічний',
  'All must approve': 'Усі мають погодити',
  'Approval rules': 'Правила погодження',
  'How much do we need approves to finish document':
    'Скільки погоджень потрібно для завершення документа',
  'Save route for quick usage': 'Зберегти маршрут для швидкого використання',
  Private: 'Приватний',
  'No saved routes': 'Збережених маршрутів немає',
  'Go to "Organizations" page and create route at "Routes" tab':
    'Перейдіть у розділ "Мої організації" та оберіть активну організацію та оберіть розділ "Маршрути" та створіть шаблон маршруту',
  'Create one time': 'Створіть один раз',
  'Saved collection of participants with roles': 'Збережіть набір отримувачів з їхніми ролями',
  'Use without limits': 'Використовуйте необмежено',
  'Select precreated route instead of manually create new each time':
    'Обирайте готовий маршрут замість ручного введення',
  'Save your time': 'Економте час',
  'For the every document send': 'На кожній відправці документа',
  'Try now': 'Спробувати зараз',
  'Auto archive documents': 'Автоматична архівація документів',
  'No more manual actions – the system will do everything for you!':
    'Більше ніяких ручних дій – система все зробить за вас!',
  'Time saving': 'Економія часу',
  'The system works automatically while you attend to important matters':
    'Система працює автоматично, поки ви займаєтесь важливими справами',
  'Flexible rules': 'Гнучкі правила',
  'Configure archiving according to your needs: immediately after completion or after a certain period of time':
    'Налаштуйте архівацію під потреби: одразу після завершення або через певний час',
  'Always tidy': 'Завжди порядок',
  'Completed items are automatically removed, but remain available in the archive':
    'Завершені автоматично прибираються, але залишаються доступними в архіві',
  'Setup auto archivation': 'Налаштувати автоархівацію',
  'Document will be approved after first approve':
    'Документ буде погоджено після першого позитивного рішення',
  Archivation: 'Автоархівація',
  'Documents auto archivation': 'Автоматична архівація документів',
  'We have created a smart system that automatically moves completed documents to the archive. No more manual actions - the system will do everything for you!':
    'Ми створили розумну систему, яка автоматично переміщає завершені документи в архів. Більше ніяких ручних дій – система все зробить за вас!',
  Autosend: 'Автовідправка',
  'Send documents when you need': 'Відправляйте документи, коли вам зручно',
  'Schedule the sending of documents for a convenient time or day. The documents will be sent automatically - you do not need to be online':
    'Заплануйте відправлення документів на зручний час або день. Документи відправляться самостійно — вам не потрібно бути онлайн',
  'Saved routes': 'Збережені маршрути',
  'Create routes for regular recipients and save time on future deliveries':
    'Створюйте маршрути для постійних отримувачів і економте час при наступних відправках',
  'Approval rule': 'Правило погодження',
  'Flexible rules - faster to document signature': 'Гнучкі правила – швидше до підпису документа',
  'Set up approval rules so that approval from one of several approvers is sufficient to continue the process':
    'Налаштуйте правила погодження так, щоб для продовження процесу вистачало схвалення від одного з кількох “апруверів”',
  'Notification about signature (CallbackURL)': 'Cповіщення про підписання (CallbackURL)',
  'Enter address where Dubidoc will send notifications':
    'Вкажіть адресу на яку Dubidoc надсилатиме повідомлення після підписання документів',
  'Add URL for getting notifications': 'Додати URL для отримання сповіщень',
  'Notification about signature': 'Cповіщення про підписання',
  'Please specify the address to which Dubidoc will send notifications after signing documents created based on this template':
    'Вкажіть адресу на яку Dubidoc надсилатиме повідомлення після підписання документів, створених на основі цього шаблону',
  'Add callbackURL': 'Додайте callbackURL',
  'Add address': 'Додати адресу',
  'URL added for getting notifications': 'Додана URL для отримання сповіщень',
  'URL for getting notifications': 'URL для отримання сповіщень',
  'Signer in document name': 'Підписант у назві документа',
  'Please specify the address to which Dubidoc will send notifications after signing documents':
    'Вкажіть адресу на яку Dubidoc надсилатиме повідомлення після підписання будь-якого надісланого вами документу',
  'After the counterparty signs the document, their surname, first name and patronymic are automatically added to the file name':
    "Після підписання документа контрагентом його прізвище, ім'я та по батькові автоматично додаються до назви файлу",
  'Add full name to document name': 'Додавати ПІБ до назви документа',
  'The full name is taken from the counterparty`s signature. If the document is signed by several persons, the full name of the first signatory is added':
    'ПІБ береться з підпису контрагента. Якщо документ підписують декілька осіб, додається ПІБ першого підписанта',
  'Full name added to document name': 'Додана ПІБ до назви документа',
  'Mass documents delete': 'Масове видалення документів',
  'In progress': 'Обробляється',
  Done: 'Виконано',
  'No request to call': 'Немає запиту для виклику',
  'Documents deleted': 'Документи видалено',
  'Some errors occur while action': 'Дія завершилась з помилками',
  'All documents failed to proceed action': 'Не вдалося виконати дію',
  Notification: 'Сповіщення',
  'Notifications settings': 'Налаштування сповіщень',
  'All changes are saved automatically. You will start receiving notifications according to the new settings':
    'Всі зміни зберігаються автоматично. Ви почнете отримувати сповіщення згідно з новими налаштуваннями',
  actives: 'активних',
  'Manage notification types': 'Керуйте типами сповіщень',
  'Which ones would you like to receive for {name}': 'Які ви хочете отримувати для {name}',
  'Turn off all': 'Вимкнути все',
  'Turn on all': 'Увімкнути все',
  'Inbox documents': 'Вхідні документи',
  'Notifications about new documents received':
    'Повідомлення про нові документи, що надійшли на ваше імʼя',
  'Signed documents': 'Підписані документи',
  'Notifications about documents signed': 'Повідомлення про успішно підписані документи',
  'Approved documents': 'Погоджені документи',
  'Notifications about documents approved': 'Повідомлення про документи, які пройшли погодження',
  'Rejected documents': 'Відхилені документи',
  'Notifications about documents rejected': 'Повідомлення про документи, які були відхилені',
  'Comments on documents': 'Коментарі до документів',
  'Notifications about new comments on your documents':
    'Повідомлення про нові коментарі до ваших документів',
  'Uncompleted actions': 'Невиконані дії',
  'Notifications about uncompleted actions': 'Повідомлення про невиконані дії',
  'Changes have been saved automatically': 'Зміни збережено автоматично',
  'Awaits signature': 'Очікує підписання',
  'Stop delete': 'Перервати видалення',
  'Delete documents': 'Видалити документи',
  'Unable to delete the document — it is pending or has already been signed by the counterparty':
    'Не вдалося видалити документ — він є вхідним або вже підписаний контрагентом',
  'Avaiable sign types': 'Доступні способи підпису',
  'What electronic signature methods will be available to your recipients when signing documents':
    'Які методи електронного підпису будуть доступні вашим отримувачам при підписанні документів',
  'How does recipient see it?': 'Як це бачить отримувач',
  iit: 'Ключ ЕЦП (файловий)',
  diia: 'Дія.Підпис',
  smart_id: 'Приват SmartID',
  mono: 'Monobank КЕП',
  'Like this recipient will see it': 'Так це побачить отримувач',
  'Select signature method': 'Оберіть спосіб підпису',
  iitDescription: 'Традиційний електронний підпис з файлом ключа',
  diiaDescription: 'Кваліфікований підпис через застосунок Дія',
  monoDescription: 'Кваліфікований підпис для клієнтів Monobank',
  smartIdDescription: 'Кваліфікований підпис через сервіс SmartID',
  'High level': 'Високий рівень',
  Supplier: 'Постачальник',
  iitSupplier: 'АЦСК України',
  diiaSupplier: 'Міністерство цифрової трансформації',
  smartIdSupplier: 'SmartID',
  monoSupplier: 'Monobank',
  Classic: 'Класичний',
  'Token/filen required': 'Потребує токен/файл',
  Fast: 'Швидкий',
  'Without tokens': 'Без токенів',
  Mobile: 'Мобільний',
  Universal: 'Універсальний',
  'For monobank clients': 'Для клієнтів Monobank',
  'Free ': 'Безкоштовний',
  'Settings have been saved': 'Налаштування збережено',
  'Card for automatic payment': 'Картка для автооплати',
  'Manage card for automatic payment for premium plan':
    'Керуйте карткою для автоматичного списання коштів за Premium-тариф',
  'You don`t have any cards added for automatic payments yet':
    'У вас поки немає доданої картки для автоматичних списань',
  'Add card': 'Додати картку',
  'Automatic withdraw': 'Автоматичне списання',
  'Setup autopayment': 'Налаштувати автоплату',
  'Autopayment is a feature that allows you to automatically pay for your subscription':
    'Додайте банківську картку для автоматичного списання коштів за Premium-тариф',
  'Card has been added for autopayment': 'Картку додано для автооплати',
  ActiveFeminine: 'Активна',
  InactiveFeminine: 'Неактивна',
  'Your card will be used to automatically renew your Premium subscription. We will send you a notification 3 days before the next payment is due.':
    'Ваша картка буде використовуватись для автоматичного поновлення Premium-тарифу. Ми надішлемо сповіщення за 10 дні до наступного списання',
  'Your card will be used to automatically renew your Premium subscription. We will send you a notification 10 days before the next payment is due.': 'Ваша картка буде використовуватись для автоматичного поновлення Premium-тарифу. Ми надішлемо сповіщення за 10 дні до наступного списання',
  'Manage card': 'Керувати карткою',
  'Credit card for automatic payment for Premium plan':
    'Банківська картка для автоматичного списання коштів за Premium-тариф',
  'Term of validity': 'Термін дії',
  'Card has been deleted from autopayment': 'Картку видалено з автооплати',
  'Generate act': 'Сформувати акт звірки',
  'Select period for act generation': 'Оберіть період для формування акту звірки розрахунків',
  'Download Excel': 'Завантажити Excel',
  'Or specify the period manually': 'Або вкажіть період вручну',
  'Select date range': 'Оберіть діапазон дат',
  'Quick period selection': 'Швидкий вибір періоду',
  'Last month': 'Останній місяць',
  'Last 3 months': 'Останні 3 місяці',
  'Last quarter': 'Останній квартал',
  'Current year': 'Поточний рік',
  'Act has been generated': 'Акт звірки сформовано',
  'Skip payment validation': 'Пропустити валідацію платежу',
  Payer: 'Платник',
  'Send as documents bundle': 'Надіслати, як комплект документів',
  'Recipients will sign once, the signature will be applied to all files':
    'Одержувачі підписуються один раз, підпис застосовується до всіх файлів',
  'Sign all at once': 'Підписати все одним кліком',
  'Documents bundle': 'Комплект документів',
  pages: '{count} сторінка | {count} сторінки | {count} сторінок',
  'Add more': 'Додати ще',
  'Link documents': 'Повʼязати документи',
  'Connection with': 'Звʼязок з',
  'Link up documents': 'Звʼязати документи',
  'Documents package': 'Комплекти документів',
  'Send documents bundle by one click': 'Надсилайте пакет документів одним кліком',
  'Your partner signs all at once, and we automatically apply the signature to each file separately. To activate, you need to upload a minimum of 2 files':
    'Ваш партнер підписує все одним натисканням, а ми автоматично накладаємо підпис на кожен файл окремо. Для активації потрібно завантажити мінімум 2 файли',
  'Sign and send bundle': 'Підписати та надіслати пакет',
  'Send bundle on sign': 'Надіслати пакет на підпис',
  'Act has been signed successfully': 'Акт успішно підписано',
  'Download signed act': 'Завантажити підписаний акт',
  'View and sign': 'Переглянути та підписати',
  'Download protocol': 'Завантажити протокол',
  'Try Premium 14 days for free': 'Спробуйте Premium 14 днів безкоштовно',
  'To activate it - add an organization. After that you will immediately get access to all Premium features:': 'Щоб активувати його - додайте організацію. Після цього ви одразу отримаєте доступ до всіх можливостей Premium:',
  'Select organization': 'Оберіть організацію',
  'Sign bundle': 'Підписати пакет',
  'Bundle has been successfully sent': 'Пакет успішно надіслано',
  'Bundle delivery is currently unavailable for this route because it contains the "Approve" action.': 'Для цього маршруту пакетна доставка наразі недоступна, оскільки він містить дію «Погодити».',
  'Set saved route or create new': 'Оберіть збережений маршрут або задайте його власноруч',
  'Related documents': 'Повʼязані документи',
  Image: 'Зображення',
  'Check and confirm the photo': 'Перегляньте та підтвердьте фото',
  'Change image': 'Замінити фото'
}
